// App.js
import React, { useMemo, useState, useEffect, useRef } from 'react';
import {
  Box, Typography, TextField, MenuItem, Button,
  Card, CardContent, Chip, Stack,
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Divider, Tooltip,
  LinearProgress, Select,Checkbox,  InputLabel, FormControl,
  Container,  Paper, Grid, ButtonGroup, Switch, FormControlLabel,   Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  FormGroup,
  ListSubheader,

} from '@mui/material';
// ✅ add these at the top with your other imports
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import { onSnapshot, startAfter } from 'firebase/firestore';
import {
      limit as qLimit
} from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid'; // if not already present: npm i uuid
import Autocomplete from '@mui/material/Autocomplete';
import Popper from '@mui/material/Popper';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import SortIcon from '@mui/icons-material/Sort';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';   // AI sparkle icon
import PsychologyIcon from '@mui/icons-material/Psychology';     // optional alt AI icon
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import logo from './leadfeed.png';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

import { db } from './firebase';
import {
  getFirestore, serverTimestamp, setDoc, doc, getDocs, collection, query,
  orderBy, limit, deleteDoc, addDoc,
  where
} from 'firebase/firestore';
// Base URLs
const DEV_BASE  = 'http://localhost:4001'; 
const PROD_BASE = 'https://api-vasejd2hkq-uc.a.run.app'; // your Cloud Function URL

// Paths
const DEV_PATH  = '/scrape';   // local backend
const PROD_PATH = '/scrapes';  // cloud function
// Cloud Functions base URL (prod) with .env override for dev/staging
// Live Cloud Function base (prod)
const API_BASE =
  process.env.REACT_APP_API_URL ||
  'https://api-vasejd2hkq-uc.a.run.app';

// Local Node server base JUST for /scrape while testing


// Minimal fetch helper for the live API
async function apiFetch(path, { method = 'GET', body, headers } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...(headers || {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const text = await res.text();
  let json; try { json = JSON.parse(text); } catch { json = { raw: text }; }
  if (!res.ok) throw new Error(`[${method} ${path}] ${json?.error || text || `HTTP ${res.status}`}`);
  return json;
}
/* ===================== FIREBASE ===================== */
// === NEW: collections for logs ===
const COLL_SCRAPES = 'scrapes';     // one doc per scrape run
const COLL_LOGS = 'lead_logs';
const COLL = 'scrape1';
const COLL_SAVED = 'savedLeads';
const COLL_UP = 'review_up';
const COLL_DOWN = 'review_down';
/* ==================================================== */

/* ===================== RAPIDAPI (Skip Trace) ===================== */
const RAPID_HOST = 'skip-tracing-working-api.p.rapidapi.com';
const RAPID_KEY  = '9a9f567ca7mshde6da4d9e730111p1d71efjsn5f96bb14baee';

// Make a short id
const rid = () => Math.random().toString(36).slice(2,10);

// Create a log at START


// List logs (newest first)
async function loadScrapeLogs(limitTo = 200) {
  if (!db) return [];
  const q1 = query(collection(db, COLL_SCRAPES), orderBy('startedAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push({ id: d.id, ...d.data() }));
  return rows;
}

// Leads by scrape
async function loadLeadsByScrape(scrapeId, limitTo = 4000) {
  if (!db || !scrapeId) return [];
  const q1 = query(collection(db, COLL), where('scrapeId', '==', scrapeId), orderBy('createdAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}
function leadKey(post){ return makeKey(post); }

async function logEvent(post, type, payload = {}) {
  if (!db) return;
  const key = leadKey(post);
  const parent = collection(db, COLL_LOGS, key, 'events');
  await addDoc(parent, {
    type,                 // 'captured' | 'call' | 'review_up' | 'review_down' | 'note'
    at: serverTimestamp(),
    payload,              // { sourceTs?, note?, meta? }
  });
}

async function fetchTimeline(post, max = 200) {
  if (!db) return [];
  const key = leadKey(post);
  const q1 = query(collection(db, COLL_LOGS, key, 'events'), orderBy('at', 'desc'), limit(max));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push({ id: d.id, ...d.data() }));
  return rows;
}

// Ensure we have a "captured" event (use post.capturedAt as the source time hint)
async function ensureCapturedEvent(post) {
  const events = await fetchTimeline(post, 20);
  const has = events.some(e => e.type === 'captured');
  if (!has) {
    await logEvent(post, 'captured', { sourceTs: post.capturedAt || null });
    return fetchTimeline(post); // re-fetch so UI shows it
  }
  return events;
}
async function skipTraceSearch({ mode = 'byname', name = '', street = '', citystatezip = '', page = 1 }) {
  const base = `https://${RAPID_HOST}/search`;
  let url = '';
  const p = new URLSearchParams({ page: String(page) });

  if (mode === 'bynameaddress') {
    if (name) p.set('name', name);
    if (citystatezip) p.set('citystatezip', citystatezip);
    url = `${base}/bynameaddress?${p.toString()}`;
  } else if (mode === 'byaddress') {
    if (street) p.set('street', street);
    if (citystatezip) p.set('citystatezip', citystatezip);
    url = `${base}/byaddress?${p.toString()}`;
  } else {
    if (name) p.set('name', name);
    url = `${base}/byname?${p.toString()}`;
  }

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'x-rapidapi-host': RAPID_HOST,
      'x-rapidapi-key': RAPID_KEY,
    },
  });

  const text = await res.text();
  if (!res.ok) throw new Error(`SkipTrace HTTP ${res.status}: ${text.slice(0,180)}`);
  let data;
  try { data = JSON.parse(text); } catch { throw new Error('SkipTrace response not JSON'); }
  return data;
}
// --- helpers (keep in same file) ---
function isTreeLead(post) {
  const t = String(post?.meta?.type || post?.type || '').toLowerCase();
  const c = String(post?.classification || '').toLowerCase();
  const tags = Array.isArray(post?.meta?.tags)
    ? post.meta.tags.map(x => String(x?.id || '').toLowerCase())
    : Array.isArray(post?.tags)
      ? post.tags.map(x => String(x?.id || '').toLowerCase())
      : [];

  if (t.includes('tree')) return true;
  if (c === 'tree' || c.includes('tree')) return true;
  if (tags.some(id => id.includes('tree'))) return true;
  return false;
}

async function fetchTreeCallScript(post, aiSummaryText) {
  const payload = {
    post: {
      author: post?.author || '',
      text: cleanFbNoise(post?.text || ''),
      lang: post?.lang || 'en',
      translatedEn: post?.translatedEn || '',
      permalink: post?.permalink || '',
      profileUrl: post?.profileUrl || '',
      timestamp: post?.timestamp ?? null,
    },
    meta: {
      classification: post?.classification || '',
      type: post?.type || '',
      market: post?.market || post?.searchMarket || '',
      searchPhrase: post?.searchPhrase || '',
      platform: post?.platform || 'facebook',
    },
    aiSummaryText: String(aiSummaryText || ''),
    // lightweight instruction so backend knows what to do
    instruction: `
Generate a short, friendly PHONE CALL SCRIPT for a sales rep at a tree service company.
Make it sound human and kind, not robotic. Use the info in the post and the AI summary.
Goals:
1) Confirm they're seeking help (removal/trim/stump/emergency)
2) Clarify location & timing (today/this week)
3) Qualify: tree count, height/size, hazards (near roof, power lines), access
4) Offer next step: free estimate/site visit; schedule a time
5) Handle light objection (“just price shopping”) with empathy
6) Close with clear next step

Format:
- Opener (one or two sentences)
- 3–5 short question bullets
- Offer & next step (one or two sentences)
- Soft close (one sentence)

Keep it under ~160 words. Use the name “we” for the company. No placeholders like {{name}}.
If it looks like a contractor ad, return a 1-line polite note saying it's likely a vendor post.
`.trim(),
  };

  // Primary endpoint (name it how you prefer)
  try {
    const data = await apiFetch('/ai/call-script', { method: 'POST', body: payload });
    return { text: data?.text || '' };
  } catch (e1) {
    // Fallback (keep consistent with your pattern)
    const data = await apiFetch('/ai/script', { method: 'POST', body: payload });
    return { text: data?.text || '' };
  }
}
async function skipTraceDetailsById(peo_id) {
  const url = `https://${RAPID_HOST}/search/detailsbyID?peo_id=${encodeURIComponent(peo_id)}`;
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'x-rapidapi-host': RAPID_HOST,
      'x-rapidapi-key': RAPID_KEY,
    },
  });
  const text = await res.text();
  if (!res.ok) throw new Error(`SkipTrace details HTTP ${res.status}: ${text.slice(0,180)}`);
  let data;
  try { data = JSON.parse(text); } catch { throw new Error('SkipTrace details response not JSON'); }
  return data;
}
/* ==================================================== */

// ---------- helpers ----------
const canonUrl = (u) => {
  try {
    if (!u) return '';
    if (u.startsWith('/')) u = 'https://www.facebook.com' + u;
    const url = new URL(u);
    url.hostname = url.hostname.replace(/^m\./i, 'www.');
    url.hash = '';
    const keep = new Set(['id', 'story_fbid']);
    [...url.searchParams.keys()].forEach(k => { if (!keep.has(k)) url.searchParams.delete(k); });
    let path = url.pathname.replace(/\/+$/, '');
    if (path === '') path = '/';
    return `${url.protocol}//${url.hostname}${path}${url.search ? '?' + url.searchParams.toString() : ''}`;
  } catch {
    return u || '';
  }
};
const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();
const safeLC = (s) => norm(s).toLowerCase();
// Remove the "Facebook Facebook Facebook ..." prefix that some posts carry
function cleanFbNoise(text = "") {
  return String(text).replace(/^(Facebook\s*){2,}/i, "").trim();
}
const hash = (s) => { let h = 2166136261 >>> 0; for (let i=0;i<s.length;i++){h^=s.charCodeAt(i);h=(h*16777619)>>>0;} return h.toString(36); };
const jaccard = (a, b) => {
  const A = new Set(safeLC(a).split(/\W+/).filter(Boolean));
  const B = new Set(safeLC(b).split(/\W+/).filter(Boolean));
  if (!A.size || !B.size) return 0;
  let inter = 0; for (const w of A) if (B.has(w)) inter++;
  return inter / (A.size + B.size - inter);
};
function safeId(str = '') {
  try {
    return btoa(unescape(encodeURIComponent(str)))
      .replace(/\//g, '_')
      .replace(/\+/g, '-'); // make it Firestore-safe
  } catch {
    return hash(str); // fallback: just hash if it breaks
  }
}
const makeKey = (p) => {
  const permalink = canonUrl(p.permalink || '');
  const profile = canonUrl(p.profileUrl || '');
if (permalink) return `u:${safeId(permalink)}`;
  if (profile && p.timestamp) return `t:${profile}::${p.timestamp}`;
  const textSig = hash(safeLC((p.text || '').slice(0, 400)));
  return `x:${textSig}`;
};

// naive parsers for Skip Trace defaults
const stripEmojiEtc = (s='') => s.replace(/[\u{1F300}-\u{1FAFF}\u{1F1E6}-\u{1F1FF}]/gu, '').trim();
const guessNameFromAuthor = (author='') => {
  const a = stripEmojiEtc(author).split(' · ')[0].split(' | ')[0];
  return a.replace(/\((admin|moderator|agent|realtor)\)/ig, '').trim();
};

// ---- SkipTrace detail helpers (robust to weird key names) ----
const val = (obj, ...keys) => {
  for (const k of keys) {
    if (obj && obj[k] != null && obj[k] !== '') return obj[k];
  }
  return '';
};
const asArr = (x) => (Array.isArray(x) ? x : x ? [x] : []);
const phoneMask = (p='') => String(p).replace(/[^\d]/g,'').replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3');

const getSummary = (d) => ({
  name: val(d, 'Full Name', 'full_name', 'Name', 'name'),
  age:  val(d, 'Age', 'age', 'Age Range', 'age_range'),
  dob:  val(d, 'DOB', 'dob', 'Date Of Birth', 'date_of_birth'),
  aka:  asArr(val(d, 'Aliases', 'AKA', 'Also Known As', 'aliases')),
});

const getPhones = (d) =>
  asArr(val(d, 'Phones', 'phones', 'Phone Numbers', 'phone_numbers'))
    .map(p => (typeof p === 'string' ? { number: p } : p));

const getEmails = (d) =>
  asArr(val(d, 'Emails', 'emails', 'Email Addresses', 'email_addresses'))
    .map(e => (typeof e === 'string' ? { email: e } : e));

const getAddresses = (d) =>
  asArr(val(d, 'Addresses', 'addresses', 'Address History', 'address_history')).map(a => ({
    line: val(a, 'Address', 'address', 'Street', 'street', 'Line1', 'line1'),
    city: val(a, 'City', 'city'),
    state: val(a, 'State', 'state'),
    zip: val(a, 'ZIP', 'Zip', 'zip'),
    from: val(a, 'From', 'from', 'Start', 'start'),
    to:   val(a, 'To', 'to', 'End', 'end'),
  }));

const getRelatives = (d) =>
  asArr(val(d, 'Relatives', 'relatives', 'Associates', 'associates')).map(r => ({
    name: val(r, 'Name', 'name', 'Full Name', 'full_name'),
    relation: val(r, 'Relation', 'relation', 'Relationship', 'relationship'),
  }));

const extractCityStateZip = (text='') => {
  const m1 = text.match(/\b([A-Za-z .'-]+,\s*[A-Z]{2}\s*\d{5})\b/);
  if (m1) return m1[1].replace(/\s+/g,' ').trim();
  const m2 = text.match(/\b([A-Za-z .'-]+,\s*[A-Z]{2})\b/);
  if (m2) return m2[1].replace(/\s+/g,' ').trim();
  return '';
};

// de-dupe
const dedupePosts = (input) => {
  if (!Array.isArray(input)) return [];
  const prepared = input.map(p => ({
    ...p,
    permalink: canonUrl(p.permalink || ''),
    profileUrl: canonUrl(p.profileUrl || ''),
    author: norm(p.author || ''),
    text: norm(p.text || ''),
  }));
  const firstPass = [];
  const seen = new Set();
  for (const p of prepared) {
    const k = makeKey(p);
    if (seen.has(k)) continue;
    seen.add(k);
    firstPass.push({ ...p, __key: k });
  }
  const byAuthor = new Map();
  for (const p of firstPass) {
    const a = p.author || '—';
    if (!byAuthor.has(a)) byAuthor.set(a, []);
    byAuthor.get(a).push(p);
  }
  const final = [];
  for (const [, arr] of byAuthor) {
    const kept = [];
    for (const p of arr) {
      let dup = false;
      for (const q of kept) {
        const sim = jaccard(p.text, q.text);
        if (sim >= 0.9 || safeLC(p.text).slice(0, 180) === safeLC(q.text).slice(0, 180)) {
          const preferP = (p.permalink && !q.permalink) || (p.text || '').length > (q.text || '').length;
          if (preferP) kept.splice(kept.indexOf(q), 1, p);
          dup = true;
          break;
        }
      }
      if (!dup) kept.push(p);
    }
    final.push(...kept);
  }
  final.sort((a,b)=> (!!b.permalink-!!a.permalink));
  return final;
};
const displayKey = (p) => makeKey(p);
// Treat as "Lawncare" if the Type says so OR any tag id starts with LC
const isLawncarePost = (p) => {
  const t = String(p?.type || '').toLowerCase();
  if (t === 'lawncare' || t === 'landscaping') return true;
  return Array.isArray(p?.tags) && p.tags.some(tag => /^LC/.test(tag?.id || ''));
};
const isRoofingPost = (p) => {
  const t = String(p?.type || '').toLowerCase();
  if (t === 'roofing') return true;
  return Array.isArray(p?.tags) && p.tags.some(tag => /^RT/.test(tag?.id || ''));
};

const isTreeServicePost = (p) => {
  const t = String(p?.type || '').toLowerCase();
  if (t === 'tree service' || t === 'tree-service' || t === 'treeservice') return true;
  return Array.isArray(p?.tags) && p.tags.some(tag => /^TS/.test(tag?.id || ''));
};
// ---------- Firestore helpers ----------
async function saveOneToFirestore(post) {
  if (!db) { console.warn('[Firestore] not initialized'); return; }
  const id = makeKey(post);
  const docRef = doc(db, COLL, id);
  await setDoc(docRef, {
    ...post,
    permalink: canonUrl(post.permalink || ''),
    profileUrl: canonUrl(post.profileUrl || ''),
    _key: id,
    createdAt: serverTimestamp(),
    scrapeId: post.scrapeId || null,       // 👈 NEW
  }, { merge: true });
}

async function saveBatchToFirestore(posts) {
  if (!db) return;
  await Promise.all(posts.map(saveOneToFirestore));
}

async function deleteOneFromFirestore(post) {
  if (!db) throw new Error('[Firestore] not initialized');
  const id = makeKey(post);

  // Delete the doc from main & aux buckets
  await Promise.allSettled([
    deleteDoc(doc(db, COLL, id)),
    deleteDoc(doc(db, COLL_SAVED, id)),
    deleteDoc(doc(db, COLL_UP, id)),
    deleteDoc(doc(db, COLL_DOWN, id)),
  ]);

  // Optional: delete timeline logs subcollection
  try {
    const parent = collection(db, COLL_LOGS, id, 'events');
    const snap = await getDocs(parent);
    await Promise.allSettled(snap.docs.map(d => deleteDoc(d.ref)));
    // delete the parent doc (container) after clearing subcollection
    await deleteDoc(doc(db, COLL_LOGS, id));
  } catch (e) {
    // logs are optional — ignore if they don't exist
  }
}



// Pull “all” scrapes so we filter client-side
const MAX_PULL = 10000;
async function loadFromFirestore(limitTo = MAX_PULL) {
  if (!db) { throw new Error('[Firestore] not initialized'); }
  const collRef = collection(db, COLL);
  const q1 = query(collRef, orderBy('createdAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}

// Saved Leads helpers
async function saveLead(post) {
  if (!db) return;
  const id = makeKey(post);
  await setDoc(doc(db, COLL_SAVED, id), {
    ...post,
    _key: id,
    savedAt: serverTimestamp(),
  }, { merge: true });
}
async function removeSavedLead(post) {
  if (!db) return;
  const id = makeKey(post);
  await deleteDoc(doc(db, COLL_SAVED, id));
}
async function loadSavedLeads(limitTo = 4000) {
  if (!db) return [];
  const q1 = query(collection(db, COLL_SAVED), orderBy('savedAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}
// Review helpers (thumbs up / down)
async function saveReview(post, verdict, reason) {
  if (!db) return;
  const id = makeKey(post);
  const coll = verdict === 'up' ? COLL_UP : COLL_DOWN;

  const reviewObj = {
    verdict,
    reason,
    at: serverTimestamp(),
  };

  // Save in thumbs collection
  await setDoc(doc(db, coll, id), { ...post, _key: id, review: reviewObj }, { merge: true });

  // ✅ Also save back to main scrape collection
  await setDoc(doc(db, COLL, id), { review: reviewObj }, { merge: true });
}
async function loadReviewBucket(verdict, limitTo = 2000) {
  if (!db) return [];
  const coll = verdict === 'up' ? COLL_UP : COLL_DOWN;
  const q1 = query(collection(db, coll), orderBy('review.at', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}

// ---------- Tag helpers we’ll add to each scrape ----------
const SRC_FACEBOOK = { id: 'SRC_FB', label: 'facebook', color: '#DBEAFE' }; // pale blue
const typeTag = (t) => ({ id: `TYPE_${t.toUpperCase()}`, label: t.toLowerCase(), color: '#E9D5FF' }); // violet
const marketTag = (m) => ({ id: `MKT_${safeLC(m)}`, label: safeLC(m), color: '#FDE68A' }); // amber
const capturedTag = (iso) => ({ id: `CAP_${iso}`, label: `captured ${iso}`, color: '#D1FAE5' }); // green

// ---------- UI ----------
const chipStyles = {
  owner: { bg: '#d1fae5', fg: '#065f46' },
  prospector: { bg: '#fee2e2', fg: '#7f1d1d' },
  homeowner: { bg: '#dcfce7', fg: '#065f46' },
  uncertain: { bg: '#fde68a', fg: '#7c2d12' },
};
// ----- Nextdoor subtypes (UI label -> tag) -----
const NEXTDOOR_SUBTYPES = [
  { value: 'Nextdoor - Plumbing',     tag: { id:'TYPE_ND_PLUMBING',   label:'Type · Nextdoor · Plumbing',   color:'#c7d2fe' } },
  { value: 'Nextdoor - HVAC',         tag: { id:'TYPE_ND_HVAC',       label:'Type · Nextdoor · HVAC',       color:'#c7d2fe' } },
  { value: 'Nextdoor - Electrical',   tag: { id:'TYPE_ND_ELECTRICAL', label:'Type · Nextdoor · Electrical', color:'#c7d2fe' } },
  { value: 'Nextdoor - Roofing',      tag: { id:'TYPE_ND_ROOFING',    label:'Type · Nextdoor · Roofing',    color:'#c7d2fe' } },
  { value: 'Nextdoor - Handyman',     tag: { id:'TYPE_ND_HANDYMAN',   label:'Type · Nextdoor · Handyman',   color:'#c7d2fe' } },
  { value: 'Nextdoor - Painting',     tag: { id:'TYPE_ND_PAINTING',   label:'Type · Nextdoor · Painting',   color:'#c7d2fe' } },
  { value: 'Nextdoor - Tree Service',  tag: { id:'TYPE_ND_TREESERVICE',  label:'Type · Nextdoor · TreeService',color:'#c7d2fe' } },
  { value: 'Nextdoor - Pest Control', tag: { id:'TYPE_ND_PEST',       label:'Type · Nextdoor · Pest',       color:'#c7d2fe' } },
  { value: 'Nextdoor - Moving',       tag: { id:'TYPE_ND_MOVING',     label:'Type · Nextdoor · Moving',     color:'#c7d2fe' } },
  { value: 'Nextdoor - Cleaning',     tag: { id:'TYPE_ND_CLEANING',   label:'Type · Nextdoor · Cleaning',   color:'#c7d2fe' } },
];

const SRC_NEXTDOOR = { id:'SRC_NEXTDOOR', label:'Source · Nextdoor', color:'#DBEAFE' };

function nextdoorTagFor(typeStr) {
  return NEXTDOOR_SUBTYPES.find(s => s.value === typeStr)?.tag || null;
}
// CSV helpers
function tagsToIdList(tags=[]) { return tags.map(t=>t.id).join(';'); }
function tagsToLabelList(tags=[]) { return tags.map(t=>t.label).join(';'); }
function csvEscape(v) {
  const s = (v===undefined || v===null) ? '' : String(v);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}
function flattenPhones(list = [], details = []) {
  // Accept strings, {number}, {raw}, or full objects from "All Phone Details"
  const out = [];

  const pushNum = (raw, meta = {}) => {
    if (!raw) return;
    const digits = String(raw).replace(/\D/g, '');
    if (digits.length < 7) return;                            // ignore non-numbers
    const pretty =
      digits.length === 10
        ? `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`
        : digits.length === 11 && digits.startsWith('1')
        ? `+1 ${digits.slice(1,4)}-${digits.slice(4,7)}-${digits.slice(7)}`
        : raw;
    const parts = [pretty];
    if (meta.type) parts.push(meta.type);
    if (meta.provider) parts.push(meta.provider);
    if (meta.last || meta.last_reported) parts.push(meta.last || meta.last_reported);
    out.push(parts.join(' • '));
  };

  // Simple array: strings or { number } or { raw }
  for (const p of list) {
    if (!p) continue;
    if (typeof p === 'string') pushNum(p);
    else if (p.number) pushNum(p.number, p);
    else if (p.raw)    pushNum(p.raw, p);
    else if (p.phone)  pushNum(p.phone, p);
  }

  // Detailed list (from "All Phone Details")
  for (const d of details) {
    const raw =
      d?.phone_number || d?.number || d?.Phone || d?.phone || d?.raw;
    const meta = {
      type: d?.phone_type || d?.type || d?.Type,
      provider: d?.provider,
      last: d?.last_reported || d?.last || d?.LastReported,
    };
    pushNum(raw, meta);
  }

  // De-dupe
  return Array.from(new Set(out));
}

function flattenEmails(list = []) {
  const out = [];
  for (const e of list) {
    if (!e) continue;
    if (typeof e === 'string') out.push(e);
    else if (e.email) out.push(e.email);
    else if (e.Email) out.push(e.Email);
  }
  return Array.from(new Set(out));
}

function stringifyAddress(a = {}) {
  const line = a.line || a.Address || a.Street || a.line1 || '';
  const city = a.city || a.City || '';
  const state = a.state || a.State || '';
  const zip = a.zip || a.ZIP || a.Zip || a.postalCode || '';
  const span = a.span || a.timespan || a.date_range || '';

  const left = [line, [city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' • ');
  return span ? `${left} (${span})` : left;
}
// 🟢 NEW: CSV for Brad Leads with skip-trace fields
function makeBradCSV(rows = []) {
  const header = [
     'Title','Description','Profile URL','Post URL','Tags','Review Verdict','Review Reason',
    'AI Verdict','AI Summary',
     'SkipTrace Name','SkipTrace Age','SkipTrace DOB',
     'Phones','Emails','Addresses','Relatives'
   ];
  const lines = [header.join(',')];

  for (const r of rows) {
    const title = r.author || '';
    const description = cleanFbNoise(r.text) || '';
    const profile = r.profileUrl || '';
    const post = r.permalink || '';

    const tagParts = [];
    if (r.platform) tagParts.push(r.platform);
    if (r.market)   tagParts.push(r.market);
    if (r.type)     tagParts.push(r.type);
    if (r.capturedAt) tagParts.push(`captured ${r.capturedAt}`);
    (r.tags || []).forEach(t => t?.label && tagParts.push(t.label));
    const tags = tagParts.join('; ');

    const verdict = r.review?.verdict || '';
    const reason  = r.review?.reason  || '';
   const aiVerdict = r.aiSummary?.verdict || '';
   const aiText    = r.aiSummary?.text    || '';
    const st = r.skipTrace || {};
    const name = st?.summary?.name || '';
    const age  = st?.summary?.age  || '';
    const dob  = st?.summary?.dob  || '';

    // ✅ Phones: look in BOTH simple array and detailed array
    const stPhonesSimple  = Array.isArray(st.phones) ? st.phones : [];
    const stPhonesDetails =
      Array.isArray(st.phoneDetails) ? st.phoneDetails
      : Array.isArray(st['All Phone Details']) ? st['All Phone Details']
      : Array.isArray(st.details?.['All Phone Details']) ? st.details['All Phone Details']
      : [];
    const phones = flattenPhones(stPhonesSimple, stPhonesDetails).join('; ');

    const emails = flattenEmails(st?.emails || []).join('; ');
    const addresses = (st?.addresses || []).map(a => stringifyAddress(a)).join(' | ');
    const relatives = (st?.relatives || []).map(x =>
      [x.name, x.relation].filter(Boolean).join(' (') + (x.relation ? ')' : '')
    ).join(' | ');

   const row = [
      title, description, profile, post, tags, verdict, reason,
     aiVerdict, aiText,
      name, age, dob, phones, emails, addresses, relatives
    ].map(csvEscape);

    lines.push(row.join(','));
  }
  return lines.join('\n');
}
function makeCSV(rows) {
   const header = [
    'Title','Description','Profile URL','Post URL','Tags','Review Verdict','Review Reason',
   'AI Verdict','AI Summary'
  ];

  const lines = [header.join(',')];

  for (const r of rows) {
    const title = r.author || '';
    const description = cleanFbNoise(r.text) || '';
    const profile = r.profileUrl || '';
    const post = r.permalink || '';

    // Gather all traits/tags
    const traitParts = [];
    if (r.platform) traitParts.push(r.platform);
    if (r.market) traitParts.push(r.market);
    if (r.type) traitParts.push(r.type);
    if (r.capturedAt) traitParts.push(`captured ${r.capturedAt}`);
    if (Array.isArray(r.tags)) {
      for (const t of r.tags) {
        if (t?.label) traitParts.push(t.label);
      }
    }
    const tags = traitParts.join('; ');

    // ✅ Pull review verdict + reason if present
  const verdict   = r.review?.verdict || '';
  const reason    = r.review?.reason  || '';
  const aiVerdict = r.aiSummary?.verdict || '';
  const aiText    = r.aiSummary?.text || '';
  const row = [title, description, profile, post, tags, verdict, reason, aiVerdict, aiText].map(csvEscape);    lines.push(row.join(','));
  }

  return lines.join('\n');
}
function downloadBlob(filename, text) {
  const blob = new Blob([text], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}

export default function LeadFeed() {
  const [keyword, setKeyword] = useState('');
  const [state, setState] = useState('Ohio');
    const [legendOpen, setLegendOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [target, setTarget] = useState(25);
  const [viewingScrapeId, setViewingScrapeId] = useState(null);
  const [acOpen, setAcOpen] = useState(false);
  const [showRecentOnly, setShowRecentOnly] = useState(false);
const [showPast5DaysOnly, setShowPast5DaysOnly] = useState(false);
const [showPast2WeeksOnly, setShowPast2WeeksOnly] = useState(false);
  const [aiSummary, setAiSummary] = useState(null);        // { verdict: 'good'|'medium'|'bad', text: '...' }
const [aiSummaryLoading, setAiSummaryLoading] = useState(false);
const [aiSummaryError, setAiSummaryError] = useState('');
const aiSummaryCacheRef = useRef(new Map());             // key => { verdict, text }
  const [selected, setSelectedState] = useState(null); // shadow for types
  const [scrapeView, setScrapeView] = useState(
  () => localStorage.getItem('scrapeView') || 'wholesale'
);
const [activeTab, setActiveTab] = useState('leads'); // 'leads' | 'logs'
const [scrapeLogs, setScrapeLogs] = useState([]);
const [logsLoading, setLogsLoading] = useState(false);
const [logsError, setLogsError] = useState('');
const [activeDateWindow, setActiveDateWindow] = React.useState(null);
const [pageCursor, setPageCursor]   = React.useState(null); // last doc snapshot
const [hasMore, setHasMore]         = React.useState(true);
const [loadingMore, setLoadingMore] = React.useState(false);
const sentinelRef = React.useRef(null); // for infinite scroll
  const [campaignType, setCampaignType] = useState('Wholesale'); // <-- NEW: chosen type added to each scrape
const [nationwide, setNationwide] = useState(false);
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState('');
  const [source, setSource] = useState('saved'); // 'live' | 'firestore' | 'saved' | 'thumbs_up' | 'thumbs_down'
const [deleting, setDeleting] = useState(false);
const [aiLoading, setAiLoading] = useState(false);
const [aiError, setAiError] = useState('');
// Date range filter state
const [ndDateFilter, setNdDateFilter] = React.useState('ALL');
const [dateMode, setDateMode] = React.useState('all'); // 'all', 'single', or 'range'
const [dateSingle, setDateSingle] = React.useState(null);
const [dateRange, setDateRange] = React.useState([null, null]);
const [dateLoading, setDateLoading] = React.useState(false);
const [dateError, setDateError] = React.useState('');
const [aiSuggestions, setAiSuggestions] = useState([]); // [{term, score, thumbsUp, reason}]
const aiSuggestTimer = useRef(null);
// Scheduled scrapes (live)
const [scheduled, setScheduled] = useState([]);
const [scheduledLoading, setScheduledLoading] = useState(false);
const [scheduledError, setScheduledError] = useState('');
const scheduledUnsubRef = useRef(null);
const expectedMsRef = useRef(0);
  // Filters
  const [filterType, setFilterType] = useState('All');
  const [filterMarket, setFilterMarket] = useState('All');
  const [minOwner, setMinOwner] = useState('');
  const [maxProspector, setMaxProspector] = useState('');
  const [sortBy, setSortBy] = useState('recent'); // 'recent' | 'relevant'
// Timeline
const [timeline, setTimeline] = useState([]);
const [timelineLoading, setTimelineLoading] = useState(false);
const [noteText, setNoteText] = useState('');
  // progress UI
  const [kwFocused, setKwFocused] = useState(false);
const kwInputRef = useRef(null);

  const [progress, setProgress] = useState(0);
  const [phase, setPhase] = useState('Preparing…');
  const [eta, setEta] = useState('');
  // modal + meta state
// modal + current scrape
const [scrapeModalOpen, setScrapeModalOpen] = useState(false);
const [currentScrapeId, setCurrentScrapeId] = useState(null);
const [scrapeMeta, setScrapeMeta] = useState(null);

// keep Firestore unsubs in refs (no TDZ, safe across re-renders)
const unsubMetaRef  = useRef(null);
const unsubLeadsRef = useRef(null);
// store unsubscribers at module scope (you already declared these up top)

  const [devMode, setDevMode] = useState(() => localStorage.getItem('devMode') === '1');
  // at top of your component
const [callScript, setCallScript] = React.useState(null);
const [callScriptLoading, setCallScriptLoading] = React.useState(false);
const [callScriptError, setCallScriptError] = React.useState('');
const [leadSearch, setLeadSearch] = React.useState('');
// Nextdoor subtype state
const [nextdoorSubtype, setNextdoorSubtype] = useState('');
const ND_DATE_FILTERS = [
  { key: 'ALL',        label: 'All time' },
  { key: 'TODAY',      label: 'Today' },
  { key: 'THIS_WEEK',  label: 'This week' },
  { key: 'THIS_MONTH', label: 'This month' },
];
// convenience flag
const isNextdoorSelected =
  String(campaignType || '').toLowerCase() === 'nextdoor';
function norm(s) {
  return String(s || '').toLowerCase();
}
function textForSearch(post) {
  // author + cleaned text in one haystack
  return `${norm(post.author)} ${norm(cleanFbNoise(post.text))}`;
}

// reset script state whenever lead changes or modal re-opens

useEffect(() => {
  localStorage.setItem('scrapeView', scrapeView);
}, [scrapeView]);
const canGenerateScript = isTreeLead(selected) && !!aiSummary?.text;

async function handleGenerateScript() {
  if (!canGenerateScript) return;
  setCallScript(null);
  setCallScriptError('');
  setCallScriptLoading(true);
  try {
    const result = await fetchTreeCallScript(selected, aiSummary?.text || '');
    setCallScript(result.text || '');
  } catch (err) {
    setCallScriptError(err?.message || 'Could not generate script');
  } finally {
    setCallScriptLoading(false);
  }
}

function copyToClipboard(text) {
  try {
    navigator.clipboard.writeText(text || '');
  } catch {}
}
const statusEmoji = (s) => (s === 'success' ? '✅' : s === 'error' ? '❌' : '⏳');
useEffect(() => {
  if (activeTab === 'logs') refreshLogs();
}, [activeTab]); // put near other effects
// Use localhost:4001 in dev mode; fall back to your existing API_BASE in prod
// put near other helpers

// 🟢 NEW: preload Brad set
useEffect(() => {
  (async () => {
    try {
      const brad = await loadBradLeads(1000);
      setBradKeys(new Set(brad.map(p => makeKey(p))));
    } catch {}
  })();
}, []);

useEffect(() => {
  if (activeTab !== 'leads') return;

  // 👇 If we're looking at a specific scrape, do NOT autoload "Saved" / default.
  if (viewingScrapeId) return;
 if (source !== 'saved') return;

  setPosts([]);
  setPageCursor(null);
  setHasMore(true);
  handleLoadSaved({ initial: true });
}, [activeTab, viewingScrapeId, source]);

useEffect(() => {
  return () => detachScrapeListeners();
}, []);
const toTs = (v) => {
  if (!v) return 0;
  if (typeof v === 'number') return v;
  if (typeof v === 'string') {
    const t = Date.parse(v);
    return Number.isNaN(t) ? 0 : t;
  }
  if (v?.toDate) return v.toDate().getTime();   // Firestore Timestamp
  if (v instanceof Date) return v.getTime();
  return 0;
};
const toDate = (v) =>
  v?.toDate ? v.toDate() :
  (typeof v === 'number' ? new Date(v) :
  (typeof v === 'string' ? new Date(v) : null));
  const progressTimer = useRef(null);
  const startTs = useRef(0);
  const reqIdRef = useRef(0); // ✅ ADD THIS LINE
  // hearts
  const [savedKeys, setSavedKeys] = useState(new Set());
const [bradKeys, setBradKeys] = useState(new Set());
  // Treat these as automated runs
const isAutomated = (row) =>
  !!(
    row?.automated ||                    // explicit flag from payload/backend
    row?.source === 'scheduler' ||       // backend set a source
    /scheduler|cron|auto/i.test(row?.env || '') || // env hint
    row?.createdBy === 'scheduler'       // alternate field name
  );

function attachScheduledListener() {
  if (scheduledUnsubRef.current) scheduledUnsubRef.current(); // cleanup

  try {
    setScheduledLoading(true);
    setScheduledError('');

    // Common field names we’ll normalize:
    //  - status: 'scheduled' | 'queued' | 'pending' | 'running' | ...
    //  - scheduledFor / runAt / startsAt (Timestamp/number/ISO)
    //  - type, keyword, market, target, env
    const colRef = collection(db, 'scrapes');

    // Prefer a server-side filter if you have "status" and "scheduledFor"
    // (You may need to accept Firestore’s index prompt once.)
    let q1 = query(
      colRef,
      where('status', 'in', ['scheduled', 'queued', 'pending']),
      orderBy('scheduledFor', 'asc'),
      qLimit(50)
    );

    // If your schema doesn’t have "scheduledFor" but uses "runAt"/"startsAt",
    // you can change orderBy('scheduledFor','asc') to whichever you have.

    scheduledUnsubRef.current = onSnapshot(
      q1,
      (snap) => {
        const rows = [];
        snap.forEach((d) => {
          const x = d.data();
          const when =
            toDate(x.scheduledFor) ||
            toDate(x.runAt) ||
            toDate(x.startsAt) ||
            null;

          rows.push({
            id: d.id,
            status: x.status || 'scheduled',
            time: when,
            keyword: x.keyword || '',
            market: x.market || x.state || '—',
            type: x.type || 'Wholesale',
            target: x.target ?? 100,
            env: x.env || '',
            error: x.error || '',
            automated: !!x.automated || x.createdBy === 'scheduler',
          });
        });

        // Keep *upcoming* first; drop anything far in the past
        const now = Date.now();
        const cleaned = rows
          .filter(r => !r.time || r.time.getTime() > now - 24 * 3600 * 1000) // last 24h & future
          .sort((a, b) => (a.time?.getTime() ?? 0) - (b.time?.getTime() ?? 0));

        setScheduled(cleaned);
        setScheduledLoading(false);
      },
      (err) => {
        setScheduledError(err?.message || String(err));
        setScheduledLoading(false);
      }
    );
  } catch (e) {
    setScheduledError(e?.message || String(e));
    setScheduledLoading(false);
  }
}
function isTreeScrapeRow(row) {
  const t = String(row?.type || '').toLowerCase();
  const tid = String(row?.typeId || '').toLowerCase();

  // tolerant: accept "Tree Service", "tree-service", or tags containing it
  if (t.includes('tree')) return true;
  if (tid === 'tree-service') return true;
  if (Array.isArray(row?.tags)) {
    return row.tags.some(tag => {
      const id = String(tag?.id || tag).toLowerCase();
      return id.includes('type:tree-service') || id === 'tree' || id.includes('tree');
    });
  }
  return false;
}

const filteredScrapeLogs = useMemo(() => {
  if (scrapeView === 'tree') {
    return scrapeLogs.filter(isTreeScrapeRow);
  }
  // wholesale view = "everything else"
  return scrapeLogs.filter(r => !isTreeScrapeRow(r));
}, [scrapeLogs, scrapeView]);
function detachScheduledListener() {
  try { scheduledUnsubRef.current && scheduledUnsubRef.current(); } catch {}
  scheduledUnsubRef.current = null;
}
React.useEffect(() => {
  if (source !== 'saved') return;       // ⬅️ only infinite-scroll on Saved view
  const el = sentinelRef.current; 
   if (!el) return;

  const io = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && hasMore && !loadingMore) {
        handleLoadSaved({ initial: false });
      }
    },
    { root: null, rootMargin: '800px 0px', threshold: 0 } // prefetch before reaching bottom
  );

  io.observe(el);
  return () => io.disconnect();
}, [hasMore, loadingMore, source]);  // normalize to start of day / end of day (local time)
function startOfDayLocal(d) {
  const x = new Date(d);
  x.setHours(0,0,0,0);
  return x;
}
function endOfDayLocal(d) {
  const x = new Date(d);
  x.setHours(23,59,59,999);
  return x;
}
const startOfDayMs = (d) => {
  if (!d) return null;
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x.getTime();
};

const endOfDayMs = (d) => {
  if (!d) return null;
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x.getTime();
};



// Get a comparable timestamp off each post
const getPostTimeMs = (post) => {
  // try the cleanest first
  if (post.capturedAt) return Number(post.capturedAt);
  if (post.meta && post.meta.capturedAt) return Number(post.meta.capturedAt);
  if (post.timestamp) return Number(post.timestamp); // fallback to FB post time
  return null;
};
// 🟢 NEW: toggle helper
const toggleBrad = async (post, e) => {
  if (e) e.stopPropagation?.();
  const key = makeKey(post);
  const next = new Set(bradKeys);
  try {
    if (next.has(key)) {
      await removeFromBradLeads(post);
      next.delete(key);
    } else {
      await addToBradLeads(post);
      next.add(key);
    }
    setBradKeys(next);
  } catch (err) {
    console.warn('Brad toggle error:', err);
    setError(err?.message || String(err));
  }
};

// 🟢 NEW: view Brad
const handleViewBradLeads = async () => {
  setViewingScrapeId(null);
   setHasMore(false);
 setPageCursor(null);
  setLoading(true);
  setError('');
  setSource('brad');
  beginProgress();
  try {
    const rows = await loadBradLeads(4000);
    setPosts(rows);
  } catch (e) {
    setError(`[Brad Leads] ${e?.message || e}`);
  } finally {
    endProgress();
    setLoading(false);
  }
};
const handleFetchByDate = async () => {
  try {
    setDateError('');
    setDateLoading(true);

    if (dateMode === 'all') {
      setActiveDateWindow(null);
      setDateLoading(false);
      return;
    }

    if (dateMode === 'single') {
      if (!dateSingle) {
        setDateError('Pick a date.');
        setDateLoading(false);
        return;
      }
      const startMs = startOfDayMs(dateSingle);
      const endMs = endOfDayMs(dateSingle);
      setActiveDateWindow({ startMs, endMs });
      setDateLoading(false);
      return;
    }

    if (dateMode === 'range') {
      const [start, end] = dateRange || [];
      if (!start || !end) {
        setDateError('Pick a start and end date.');
        setDateLoading(false);
        return;
      }
      // normalize order
      const a = new Date(start);
      const b = new Date(end);
      const min = a < b ? a : b;
      const max = a < b ? b : a;

      const startMs = startOfDayMs(min);
      const endMs = endOfDayMs(max);
      setActiveDateWindow({ startMs, endMs });
      setDateLoading(false);
    }
  } catch (e) {
    setDateError(e?.message || 'Failed to apply date filter');
    setDateLoading(false);
  }
};
const requestAi = async () => {
  const id = ++reqIdRef.current;
  setAiLoading(true);
  setAiError('');
  try {
    const listRaw = await fetchAiSuggestions({
      keyword,
      state: nationwide ? 'Nationwide' : state,
      type: campaignType,
    });

    // Prefer upvoted; if none, fall back to score-based
    const sorted = (listRaw || []).sort(
      (a, b) =>
        (b.thumbsUp || 0) - (a.thumbsUp || 0) ||
        (b.score || 0) - (a.score || 0)
    );

    let list = sorted.filter(s => (s.thumbsUp ?? 0) > 0).slice(0, 8);
    if (list.length === 0) {
      // fallback: keep reasonable confidence suggestions
      list = sorted.filter(s => (s.score ?? 0) >= 0.3).slice(0, 8);
    }

    if (id === reqIdRef.current) setAiSuggestions(list);
  } catch (e) {
    if (id === reqIdRef.current) {
      setAiError(e?.message || String(e));
    }
  } finally {
    if (id === reqIdRef.current) setAiLoading(false);
  }
};

// ---------- Debounce: trigger on input changes ----------
useEffect(() => {
  if (aiSuggestTimer.current) clearTimeout(aiSuggestTimer.current);

  // skip empty
  if (!keyword.trim()) {
    setAiError('');
    setAiSuggestions([]);
    return;
  }

  aiSuggestTimer.current = setTimeout(() => {
    requestAi();
  }, 350);

  return () => {
    if (aiSuggestTimer.current) clearTimeout(aiSuggestTimer.current);
  };
}, [keyword, state, nationwide, campaignType]);
useEffect(() => {
  localStorage.setItem('devMode', devMode ? '1' : '0');
}, [devMode]);
// ---------- Fetch on focus (if nothing cached) ----------
useEffect(() => {
  if (kwFocused && keyword.trim() && aiSuggestions.length === 0 && !aiLoading) {
    requestAi();
  }
}, [kwFocused]); // eslint-disable-line react-hooks/exhaustive-deps

  // 3) on focus, fetch if nothing cached
  useEffect(() => {
    if (
      kwFocused &&
      keyword.trim() &&
      aiSuggestions.length === 0 &&
      !aiLoading
    ) {
      requestAi();
    }
  }, [kwFocused]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    (async () => {
      try {
        const saved = await loadSavedLeads(1000);
        setSavedKeys(new Set(saved.map(p => makeKey(p))));
      } catch {}
    })();
  }, []);

  // Debounced AI suggestions on input changes
function Highlighted({ text, query }) {
  const q = String(query || '').trim();
  if (!q) return <>{text}</>;
  const esc = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(`(${esc})`, 'ig');
  const parts = String(text || '').split(re);
  return (
    <>
      {parts.map((p, i) =>
        re.test(p) ? (
          <Box key={i} component="mark" sx={{ background: 'transparent', color: '#4338ca', fontWeight: 800 }}>
            {p}
          </Box>
        ) : (
          <span key={i}>{p}</span>
        )
      )}
    </>
  );
}

async function persistAiSummary(post, sum) {
  if (!db || !post || !sum) return;
  const id = makeKey(post);
  const payload = {
    aiSummary: {
      verdict: sum.verdict || '',
      text: sum.text || '',
      savedAt: serverTimestamp(),
    },
  };
  await Promise.allSettled([
    setDoc(doc(db, COLL, id), payload, { merge: true }),
    setDoc(doc(db, COLL_BRAD, id), payload, { merge: true }),
  ]);
}

async function openScrapeLogDialog(scrapeId) {
  setLogScrapeId(scrapeId);
  setLogOpen(true);
  setLogLoading(true);
  setLogError('');
  setLogLines([]);

  try {
    // live listener
    const colRef = collection(db, 'scrapes', scrapeId, 'logs');
    const q1 = query(colRef, orderBy('ts', 'asc'), limit(1000));
    if (logUnsubRef.current) logUnsubRef.current(); // cleanup old
    logUnsubRef.current = onSnapshot(q1, (snap) => {
      const rows = [];
      snap.forEach(d => rows.push({ id: d.id, ...d.data() }));
      setLogLines(rows);
      setLogLoading(false);
    }, (err) => {
      setLogError(err?.message || String(err));
      setLogLoading(false);
    });
  } catch (e) {
    setLogError(e?.message || String(e));
    setLogLoading(false);
  }
}
// 🟢 NEW: dedicated collection for Brad picks
const COLL_BRAD = 'bradLeads';

// 🟢 NEW: normalize skip-trace details → compact arrays
function flattenPhones(list=[]) {
  return list
    .map(p => (typeof p === 'string' ? p : (p.number || p.phone_number || p.Phone || '')))
    .filter(Boolean);
}
function flattenEmails(list=[]) {
  return list
    .map(e => (typeof e === 'string' ? e : (e.email || e.Email || '')))
    .filter(Boolean);
}
function stringifyAddress(a) {
  const parts = [a.line || a.Address || a.AddressLine, [a.city, a.state].filter(Boolean).join(', '), a.zip].filter(Boolean);
  return parts.join(' • ');
}

// 🟢 NEW: add/remove/load Brad picks
async function addToBradLeads(post) {
  if (!db) return;
  const id = makeKey(post);

  // mirror a doc into `brad_leads`
  await setDoc(doc(db, COLL_BRAD, id), {
    ...post,
    _key: id,
    brad: { saved: true, savedAt: serverTimestamp() },
  }, { merge: true });

  // mark the main doc too (helps filters/search)
  await setDoc(doc(db, COLL, id), {
    brad: { saved: true, savedAt: serverTimestamp() },
    type: post.type || 'Brad Leads',
  }, { merge: true });
}

async function removeFromBradLeads(post) {
  if (!db) return;
  const id = makeKey(post);
  await deleteDoc(doc(db, COLL_BRAD, id));
  await setDoc(doc(db, COLL, id), { brad: { saved: false } }, { merge: true });
}

async function loadBradLeads(limitTo = 4000) {
  if (!db) return [];
  const q1 = query(collection(db, COLL_BRAD), orderBy('brad.savedAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}

// 🟢 NEW: write skip-trace details back to a lead (main + brad mirror if present)
async function attachSkipTraceToLead(post, detail) {
  if (!db || !post || !detail) return;

  const id = makeKey(post);
  const phoneDetails = Array.isArray(detail?.['All Phone Details'])
    ? detail['All Phone Details']
    : Array.isArray(detail?.AllPhoneDetails)
    ? detail.AllPhoneDetails
    : [];

  const payload = {
    skipTrace: {
      summary:   getSummary(detail),
      phones:    getPhones(detail),      // normalized [{ raw, type, last, provider }]
      emails:    getEmails(detail),      // normalized [string]
      addresses: getAddresses(detail),
      relatives: getRelatives(detail),
      phoneDetails,                      // raw detailed phone rows (for CSV meta)
      details:   detail,                 // optional full payload
      storedAt: serverTimestamp(),
      source: 'rapidapi/skip-tracing-working-api',
    },
  };

  await Promise.allSettled([
    setDoc(doc(db, COLL, id), payload, { merge: true }),
    setDoc(doc(db, COLL_BRAD, id), payload, { merge: true }),
  ]);
}
function closeScrapeLogDialog() {
  setLogOpen(false);
  setLogScrapeId(null);
  setLogLines([]);
  if (logUnsubRef.current) { try { logUnsubRef.current(); } catch {} logUnsubRef.current = null; }
}
// only a confidence percentage pill
function SuggestMeta({ score = 0.6 }) {
  const pct = Math.round(Math.max(0, Math.min(1, Number(score))) * 100);
  return (
    <Box
      sx={{
        px: .75, py: .25, borderRadius: 1,
        border: '1px solid #e5e7eb',
        fontSize: 12, fontWeight: 700,
        color: '#111827', minWidth: 42, textAlign: 'center',
      }}
      title={`Confidence: ${pct}%`}
    >
      {pct}%
    </Box>
  );
}
// ===== Skip Trace helpers (scoring + field mappers) =====
// ===== Skip Trace helpers (robust parsing + scoring tuned to "Lives in") =====
// ===== Skip Trace helpers (DMV-first scoring, robust parsing) =====
const STATE_NAME_TO_POSTAL = {
  'ALABAMA':'AL','ALASKA':'AK','ARIZONA':'AZ','ARKANSAS':'AR','CALIFORNIA':'CA','COLORADO':'CO',
  'CONNECTICUT':'CT','DELAWARE':'DE','DISTRICT OF COLUMBIA':'DC','WASHINGTON, DC':'DC','WASHINGTON DC':'DC','D.C.':'DC','DC':'DC',
  'FLORIDA':'FL','GEORGIA':'GA','HAWAII':'HI','IDAHO':'ID','ILLINOIS':'IL','INDIANA':'IN','IOWA':'IA','KANSAS':'KS','KENTUCKY':'KY',
  'LOUISIANA':'LA','MAINE':'ME','MARYLAND':'MD','MASSACHUSETTS':'MA','MICHIGAN':'MI','MINNESOTA':'MN','MISSISSIPPI':'MS','MISSOURI':'MO',
  'MONTANA':'MT','NEBRASKA':'NE','NEVADA':'NV','NEW HAMPSHIRE':'NH','NEW JERSEY':'NJ','NEW MEXICO':'NM','NEW YORK':'NY',
  'NORTH CAROLINA':'NC','NORTH DAKOTA':'ND','OHIO':'OH','OKLAHOMA':'OK','OREGON':'OR','PENNSYLVANIA':'PA','RHODE ISLAND':'RI',
  'SOUTH CAROLINA':'SC','SOUTH DAKOTA':'SD','TENNESSEE':'TN','TEXAS':'TX','UTAH':'UT','VERMONT':'VT','VIRGINIA':'VA',
  'WASHINGTON':'WA','WEST VIRGINIA':'WV','WISCONSIN':'WI','WYOMING':'WY'
};
const DMV = new Set(['DC','MD','VA']);

const normStr = (s) => String(s ?? '').trim();
const upper = (s) => normStr(s).toUpperCase();
const firstNonEmpty = (...vals) => vals.find(v => v != null && String(v).trim() !== '') ?? '';

const recId = (r) => firstNonEmpty(r['Person ID'], r.PersonID, r.id, r.Id);
const recName = (r) => firstNonEmpty(r.Name, r['Full Name'], r.PersonName, r['Person Name'], r.Person, r.FullName);
const recLivesIn = (r) => firstNonEmpty(
  r['Lives in'], r.LivesIn, r.Lives_in, r.Lives, r.Address, r.address,
  (r.City && r.State) ? `${r.City}, ${r.State}` : ''
);
const STATES = {
  'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
  'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
  'DC': 'District of Columbia', 'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii',
  'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
  'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
  'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
  'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
  'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
  'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
  'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island',
  'SC': 'South Carolina', 'SD': 'South Dakota', 'TN': 'Tennessee',
  'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont', 'VA': 'Virginia',
  'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming',
};
async function sendFeedbackToBackend(post, verdict, reason) {
  const payload = {
    verdict: verdict === 'up' ? 'up' : 'down',
    text: cleanFbNoise(post?.text || ''),
    author: post?.author || null,
    permalink: post?.permalink || post?.profileUrl || null,
    market: post?.market || post?.searchMarket || '__NATIONWIDE__',
    tags: Array.isArray(post?.tags)
      ? post.tags.map(t => ({ id: t.id, label: t.label, color: t.color })).slice(0, 20)
      : [],
    ownerScore: Number.isFinite(post?.ownerScore) ? post.ownerScore : null,
    prospectorScore: Number.isFinite(post?.prospectorScore) ? post.prospectorScore : null,
    classification: post?.classification || null,
    reason: reason || '',
    searchPhrase: post?.searchPhrase || '',
    searchMarket: post?.searchMarket || '',
    searchType: post?.searchType || '',
    capturedAt: post?.capturedAt || null,
    platform: post?.platform || 'facebook',
  };
  return apiFetch('/feedback', { method: 'POST', body: payload });
}

// Count passed/failed/total for a scrapeId from the same leads coll you're using elsewhere
async function deriveCountsFromLeads(db, runId) {
  // NOTE: COLL is 'scrape1' in your file; that’s where your leads live.
  const snap = await getDocs(
    query(collection(db, COLL), where('scrapeId', '==', runId))
  );

  let passed = 0;
  let failed = 0;

  snap.forEach((d) => {
    // using data() is fine; verdict is stored on the lead docs
    const v = d.data()?.verdict;
    if (v === 'good') passed++;
    else if (v === 'bad') failed++;
  });

  return { passed, failed, total: snap.size };
}
function getLeadDomain(lead) {
  const t = String((lead && (lead.meta && lead.meta.type)) || lead && lead.type || '').toLowerCase();
  const c = String((lead && lead.classification) || '').toLowerCase();
  const tags = Array.isArray(lead && lead.tags) ? lead.tags.map(x => String((x && x.id) || x || '').toLowerCase()) : [];

  // tree signals
  if (t.includes('tree')) return 'tree';
  if (c === 'tree' || c.includes('tree')) return 'tree';
  if (tags.some(id => id.includes('type:tree') || id.includes('tree'))) return 'tree';

  // wholesale signals (so we can mark unknowns as wholesale by default later)
  if (t.includes('wholesale') || c === 'wholesale' || c.includes('wholesale')) return 'wholesale';

  return 'unknown';
}

function buildTreePrompt({ text, market, keyword }) {
  const safeText = String(text || '');
  const safeMarket = String(market || 'N/A');
  const safeKeyword = String(keyword || 'N/A');

  return `
You score Facebook posts for TREE SERVICE leads.

GOAL
- Approve genuine homeowners seeking tree work (removal, trimming, stump, emergency).
- Reject vendor/self-promo/hashtag spam or lawn-only services.

RETURN FORMAT
Strict JSON only, no extra text:
{"verdict":"good|medium|bad","reasons":["...","..."]}

INPUT POST
${safeText}

CONTEXT
- Market: ${safeMarket}
- Search keyword: ${safeKeyword}

SCORING RULES
GOOD:
- First-person or clearly hiring for tree removal/trim/stump.
- Emergency need (fallen tree, on house, blocking driveway, storm).
- Geo relevance helps but isn't required.

MEDIUM:
- Likely a request but vague; missing first-person or specifics.

BAD:
- Vendor ad/self-promo (licensed/insured/free estimates, call/text, lots of hashtags).
- Lawn-only (mow, mulch, sod) with no tree work.
- Irrelevant.

Think step-by-step internally but ONLY output the JSON object.`;
}

function normalizeVerdict(v) {
  const s = String(v || '').toLowerCase();
  if (['good','pass','approve','approved'].includes(s)) return 'good';
  if (['medium','maybe','borderline'].includes(s)) return 'medium';
  // everything else → bad
  return 'bad';
}
function makeKey(lead) {
  const domain = getLeadDomain(lead);
  const idish =
    (lead && lead._id) ||
    (lead && lead.permalink) ||
    (lead && lead.profileUrl) ||
    (lead && lead.text) ||
    Math.random().toString(36).slice(2);
  return `${domain}|${idish}`;
}
async function fetchAiLeadSummary(post) {
  // --- helper: domain detection ---
  function getLeadDomain(p) {
    const t = String((p?.meta?.type || p?.type || '')).toLowerCase();
    const c = String(p?.classification || '').toLowerCase();
    const tags = Array.isArray(p?.meta?.tags)
      ? p.meta.tags.map(x => String(x?.id || '').toLowerCase())
      : [];
    if (t.includes('tree')) return 'tree';
    if (c === 'tree' || c.includes('tree')) return 'tree';
    if (tags.some(id => id.includes('tree'))) return 'tree';
    return 'wholesale';
  }

  // --- helper: nextdoor detection ---
  function isNextdoor(p) {
    const type = String(p?.meta?.type || p?.type || '').toLowerCase();
    const typeId = String(p?.meta?.typeId || p?.typeId || '').toLowerCase();
    const platform = String(p?.platform || '').toLowerCase();
    const source = String(p?.source || '').toLowerCase();
    return (
      type === 'nextdoor' ||
      typeId === 'nextdoor' ||
      platform === 'nextdoor' ||
      source === 'nextdoor'
    );
  }

  // --- helper: verdict normalization ---
  function normalizeVerdict(v) {
    const s = String(v || '').toLowerCase();
    if (['good','pass','approve','approved'].includes(s)) return 'good';
    if (['medium','maybe','borderline'].includes(s)) return 'medium';
    return 'bad';
  }

  // --- helper: build tree prompt (text only, same endpoint) ---
  function buildTreePrompt({ text, market, keyword }) {
    const safeText = String(text || '');
    const safeMarket = String(market || 'N/A');
    const safeKeyword = String(keyword || 'N/A');

    return `
You score Facebook posts for TREE SERVICE leads.

GOAL
- Approve genuine homeowners seeking tree work (removal, trimming, stump, emergency).
- Reject vendor/self-promo or lawn-only services.

RETURN FORMAT
Strict JSON only: {"verdict":"good|medium|bad","reasons":["...","..."]}

INPUT POST
${safeText}

CONTEXT
- Market: ${safeMarket}
- Search keyword: ${safeKeyword}

RULES
GOOD: first-person or clearly hiring for tree removal/trim/stump, emergency needs.
MEDIUM: might be a request but vague.
BAD: vendor ad, self-promo, or unrelated.`;
  }

  const domain = getLeadDomain(post);
  const nextdoor = isNextdoor(post);

  // --- shared payload ---
  const payload = {
    post: {
      author: post?.author || '',
      text: cleanFbNoise ? cleanFbNoise(post?.text || '') : (post?.text || ''),
      lang: post?.lang || 'en',
      translatedEn: post?.translatedEn || '',
      permalink: post?.permalink || '',
      profileUrl: post?.profileUrl || '',
      timestamp: post?.timestamp || null,
      platform: post?.platform || null,
      source: post?.source || null,
    },
    scores: {
      ownerScore: post?.ownerScore ?? null,
      prospectorScore: post?.prospectorScore ?? null,
    },
    meta: {
      classification: post?.classification || '',
      type: post?.type || post?.meta?.type || '',
      typeId: post?.typeId || post?.meta?.typeId || '',
      market: post?.market || post?.searchMarket || '',
      tags: (post?.tags || []).map(t => ({ id: t.id, label: t.label })),
      searchPhrase: post?.searchPhrase || '',
      capturedAt: post?.capturedAt || null,
      platform: post?.platform || 'facebook',
    },
    minSentences: 5,
    maxSentences: 10,
  };

  // include tree prompt only for tree domain (same endpoint logic as before)
  if (domain === 'tree') {
    payload.treePrompt = buildTreePrompt({
      text: post?.text,
      market: post?.market || post?.searchMarket,
      keyword: post?.searchPhrase || '',
    });
  }

  // Pick endpoint: Nextdoor → nextdoor-summary, otherwise general lead-summary
  const primaryEndpoint = nextdoor ? '/ai/nextdoor-summary' : '/ai/lead-summary';

  try {
    const data = await apiFetch(primaryEndpoint, { method: 'POST', body: payload });
    return {
      verdict: normalizeVerdict(data?.verdict || ''),
      text: data?.text || '',
    };
  } catch (err) {
    console.warn(`${primaryEndpoint} failed, fallback to /ai/summary:`, err?.message);
    try {
      const data = await apiFetch('/ai/summary', { method: 'POST', body: payload });
      return {
        verdict: normalizeVerdict(data?.verdict || ''),
        text: data?.text || '',
      };
    } catch (err2) {
      console.error('Both AI summary calls failed:', err2?.message);
      throw err2;
    }
  }
}
async function handleDeleteFromDB(post) {
  if (!post) return;
  const ok = window.confirm('Delete this post from the database and remove it from the list?');
  if (!ok) return;

  setDeleting(true);
  try {
    await deleteOneFromFirestore(post);

    // Remove from current screen lists
    setPosts(prev => prev.filter(p => makeKey(p) !== makeKey(post)));
    setSavedKeys(prev => {
      const next = new Set(prev);
      next.delete(makeKey(post));
      return next;
    });

    // Close modal
    setDetailsOpen(false);
    setSelected(null);
  } catch (e) {
    setError(`[Delete] ${e?.message || e}`);
  } finally {
    setDeleting(false);
  }
}
const effectiveApiBase = devMode ? 'http://localhost:4001' : API_BASE;
const scrapePath = devMode ? '/scrape' : '/scrapes';
function detachScrapeListeners() {
  try { unsubMetaRef.current && unsubMetaRef.current(); } catch {}
  try { unsubLeadsRef.current && unsubLeadsRef.current(); } catch {}
  unsubMetaRef.current = null;
  unsubLeadsRef.current = null;
}

function openScrapeModal(id) {
  setCurrentScrapeId(id);
  setScrapeModalOpen(true);
}

function closeScrapeModal() {
  setScrapeModalOpen(false);
  // optional: keep id/meta visible after close, or clear:
  // setCurrentScrapeId(null);
  // setScrapeMeta(null);
}

/**
 * Subscribe to scrapes/{id} (meta) and scrapes/{id}/leads (rows)
 */
function attachScrapeListeners(id, { onMeta, onLeads } = {}) {
  // clean any prior listeners to avoid duplicates
  detachScrapeListeners();

  // meta/status doc
  const metaRef = doc(db, 'scrapes', id);
  unsubMetaRef.current = onSnapshot(
    metaRef,
    (snap) => {
      if (!snap.exists()) return;
      const data = snap.data();
      onMeta && onMeta(data);
    },
    (err) => console.warn('[scrape meta snapshot err]', err)
  );

  // leads subcollection (adjust ordering to your schema)
  const leadsRef = collection(db, 'scrapes', id, 'leads');
  const leadsQuery = query(
    leadsRef,
    orderBy('createdAt', 'asc'),   // or orderBy('__name__') if you don't store createdAt
    qLimit(2000)                   // bump limit if needed
  );

  unsubLeadsRef.current = onSnapshot(
    leadsQuery,
    (snap) => {
      const rows = [];
      snap.forEach((d) => rows.push({ id: d.id, ...d.data() }));
      onLeads && onLeads(rows);
    },
    (err) => console.warn('[scrape leads snapshot err]', err)
  );
}

// clean up on unmount
useEffect(() => () => detachScrapeListeners(), []);
// Helper: detect states mentioned in text
function detectMarkets(text = '') {
  const found = new Set();
  const lc = text.toLowerCase();

  for (const [abbr, name] of Object.entries(STATES)) {
    if (lc.includes(name.toLowerCase()) || lc.match(new RegExp(`\\b${abbr}\\b`, 'i'))) {
      found.add(name); // always store full name (e.g. "Tennessee")
    }
  }
  return Array.from(found);
}
function toPostal(stateLike){
  if (!stateLike) return '';
  const u = upper(stateLike);
  if (u.length === 2) return u;
  return STATE_NAME_TO_POSTAL[u] || '';
}
const SuggestBadge = ({ sug }) => {
  const conf = Math.round(Math.max(0, Math.min(1, Number(sug.score ?? 0.5))) * 100);
  const text = Number.isFinite(sug.thumbsUp) ? `👍 ${sug.thumbsUp}` : `${conf}%`;
  return (
    <Box sx={{ ml: 'auto', px: .75, py: .25, fontSize: 10, border: '1px solid #e5e7eb', borderRadius: 1, fontWeight: 700 }}>
      {text}
    </Box>
  );
};
function parseCityState(s){
  // "City, ST" or "City, State"
  const m = String(s||'').match(/^\s*([A-Za-z .'-]+?)\s*,\s*([A-Za-z. ]+)\s*$/);
  if (!m) return { city:'', state:'' };
  return { city: m[1].trim(), state: toPostal(m[2].trim()) };
}
function parseCityStateZipHint(hint){
  const m = String(hint||'').match(/^\s*([A-Za-z .'-]+)\s*,\s*([A-Za-z. ]+)\s*(\d{5})?\s*$/);
  if (!m) return { city:'', state:'', zip:'' };
  return { city: m[1].trim(), state: toPostal(m[2].trim()), zip: (m[3]||'').trim() };
}
function targetStatesFromMarket(market){
  const u = upper(market);
  if (u === 'DMV') return new Set(['DC','MD','VA']);
  // handle named markets in your picker
  if (u in STATE_NAME_TO_POSTAL) return new Set([STATE_NAME_TO_POSTAL[u]]);
  if (u === 'WASHINGTON, DC' || u === 'WASHINGTON DC') return new Set(['DC']);
  return new Set(); // unknown/neutral
}

const loadLogsWithCounts = React.useCallback(async () => {
  setLogsLoading(true);
  setLogsError('');
  try {
    const rows = await loadScrapeLogs(); // you already have this helper
    const withCounts = await Promise.all(
      rows.map(async (row) => {
        if (typeof row.passed === 'number' && typeof row.failed === 'number') {
          return row; // already has counts
        }
        const { passed, failed, total } = await deriveCountsFromLeads(db, row._id || row.id);
        return {
          ...row,
          passed,
          failed,
          total: row.total ?? total,
        };
      })
    );
    setScrapeLogs(withCounts);
  } catch (e) {
    setLogsError(e?.message || String(e));
  } finally {
    setLogsLoading(false);
  }
}, [db]);
function cleanName(n){
  return String(n||'').replace(/[^A-Za-z.' -]/g,' ').replace(/\s+/g,' ').trim();
}

/** DMV-first scoring:
 *  1) If market is DMV: any record in DC/MD/VA outranks non-DMV by a large margin.
 *  2) Within target state(s), exact city match from hint > name exact > has location.
 *  3) If market is a single state (e.g., Maryland), treat that as the only target.
 */
function scoreRecord(r, { market, nameHint, cityStateZipHint }){
  const lives = recLivesIn(r);
  const { city: rCity, state: rState } = parseCityState(lives);
  const statesTarget = targetStatesFromMarket(market);
  const { city: hintCity, state: hintState } = parseCityStateZipHint(cityStateZipHint);

  let score = 0;

  // Market-first weighting
  if (statesTarget.size) {
    if (rState && statesTarget.has(rState)) score += 120;   // strong boost
    else score -= 40;                                       // explicit penalty for non-targets
  } else if (hintState && rState) {
    if (hintState === rState) score += 80;
  }

  // City match (if user provided city)
  if (hintCity && rCity && upper(hintCity) === upper(rCity)) score += 50;

  // Name similarity
  const recN = upper(cleanName(recName(r)));
  const hintN = upper(cleanName(nameHint));
  if (recN && hintN) {
    if (recN === hintN) score += 15;
    else if (recN.includes(hintN) || hintN.includes(recN)) score += 7;
  }

  // Having any location helps a bit
  if (lives) score += 3;

  return score;
}

function scoreSortAndFlag(results, context){
  const scored = (results || []).map(r => ({ ...r, __score: scoreRecord(r, context) }));

  scored.sort((a,b)=>{
    const s = (b.__score||0) - (a.__score||0);
    if (s !== 0) return s;

    // Tie-breakers: is in target state, has livesIn, name asc
    const tgt = targetStatesFromMarket(context.market);
    const aState = parseCityState(recLivesIn(a)).state;
    const bState = parseCityState(recLivesIn(b)).state;
    if (tgt.size) {
      const ai = tgt.has(aState), bi = tgt.has(bState);
      if (ai !== bi) return bi - ai;
    }
    const aHas = !!recLivesIn(a), bHas = !!recLivesIn(b);
    if (aHas !== bHas) return (bHas?1:0) - (aHas?1:0);
    return (recName(a)||'').localeCompare(recName(b)||'');
  });

  // Mark "Most Likely"
  const tgt = targetStatesFromMarket(context.market);
  let topIndex = 0;
  if (tgt.size) {
    const idx = scored.findIndex(r => tgt.has(parseCityState(recLivesIn(r)).state));
    if (idx >= 0) topIndex = idx; // first target-state result wins
  }
  return scored.map((r,i)=>({ ...r, __isTop: i === topIndex && (r.__score||0) > -999 }));
}
function normalizeSuggestions(sugs) {
  if (!Array.isArray(sugs)) return [];
  return sugs
    .map((x) => {
      if (typeof x === 'string') {
        // treat bare strings from the server as valid suggestions
        return { term: x, score: 0.6, thumbsUp: 1, reason: '' };
      }
      const term = x.term || x.query || x.q || '';
      const score = Number.isFinite(x.score) ? x.score : (x.confidence ?? 0.6);
      const thumbsUp = Number.isFinite(x.thumbsUp) ? x.thumbsUp : (x.upVotes ?? 1);
      const reason = x.reason || x.explanation || '';
      return { term, score, thumbsUp, reason };
    })
    .filter((s) => s.term);
}
async function loadLeadsByDateRange(fromMs, toMs, max = 4000) {
  const db = getFirestore();
  const leadsCol = collection(db, 'leads');

  // Many of your docs already expose `capturedAt` numeric; we query on that.
  // If some only have meta.capturedAt, we’ll pull a superset and post-filter.
  const q = query(
    leadsCol,
    where('capturedAt', '>=', fromMs),
    where('capturedAt', '<=', toMs),
    orderBy('capturedAt', 'desc'),
    qLimit(max)
  );

  const snap = await getDocs(q);
  let rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));

  // Fallback: keep any that have meta.capturedAt inside range, or normalize TS -> ms
  rows = rows.filter(r => {
    const raw =
      typeof r.capturedAt === 'number' ? r.capturedAt :
      r.capturedAt?.toDate ? r.capturedAt.toDate().getTime() :
      typeof r.meta?.capturedAt === 'number' ? r.meta.capturedAt :
      r.meta?.capturedAt?.toDate ? r.meta.capturedAt.toDate().getTime() :
      null;

    if (!raw) return false;
    r.capturedAt = raw; // normalize for UI chips already using this field
    return raw >= fromMs && raw <= toMs;
  });

  return rows;
}


async function fetchAiSuggestions({ keyword, state, type }) {
  const qs = new URLSearchParams({
    keyword: keyword || '',
    state: state || 'Nationwide',
    type: type || 'Wholesale',
  }).toString();
  const data = await apiFetch(`/ai/suggest?${qs}`);
  return normalizeSuggestions(data?.suggestions || []);
}
// ---------- Details mappers ----------
function phoneMask(raw){
  const digits = String(raw||'').replace(/\D/g,'');
  if (digits.length === 10) return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+1 ${digits.slice(1,4)}-${digits.slice(4,7)}-${digits.slice(7)}`;
  return raw || '';
}
function getPhones(detail){
  const list = detail?.['All Phone Details'] || detail?.AllPhoneDetails || detail?.Phones || [];
  if (!Array.isArray(list)) return [];
  return list.map(p => ({
    raw: firstNonEmpty(p.phone_number, p.number, p.Phone, p.phone),
    type: firstNonEmpty(p.phone_type, p.type, p.Type),
    last: firstNonEmpty(p.last_reported, p.last, p.LastReported),
    provider: p.provider || ''
  })).filter(p => p.raw);
}
function getEmails(detail){
  const e = detail?.['Email Addresses'] || detail?.Emails || detail?.emails || [];
  if (!Array.isArray(e)) return [];
  return e.map(x => (typeof x === 'string' ? x : firstNonEmpty(x.email, x.Email))).filter(Boolean);
}
function getAddresses(detail){
  const current = detail?.['Current Address Details List'] || detail?.CurrentAddresses || [];
  const previous = detail?.['Previous Address Details'] || detail?.PreviousAddresses || [];

  const normCur = (x)=>({
    line: firstNonEmpty(x.street_address, x.AddressLine, x.Address),
    city: firstNonEmpty(x.address_locality, x.City),
    state: toPostal(firstNonEmpty(x.address_region, x.State)),
    zip: firstNonEmpty(x.postal_code, x.ZIP, x.Zip, x.postalCode),
    span: firstNonEmpty(x.date_range, x.timespan)
  });
  const normPrev = (x)=>({
    line: firstNonEmpty(x.streetAddress, x.AddressLine, x.Address),
    city: firstNonEmpty(x.addressLocality, x.City),
    state: toPostal(firstNonEmpty(x.addressRegion, x.State)),
    zip: firstNonEmpty(x.postalCode, x.ZIP, x.Zip, x.postalCode),
    span: firstNonEmpty(x.timespan, x.date_range)
  });

  const cur = Array.isArray(current) ? current.map(normCur) : [];
  const prev = Array.isArray(previous) ? previous.map(normPrev) : [];

  // de-dupe by line + city + state + zip + span
  const seen = new Set();
  const all = [...cur, ...prev].filter(a => {
    const key = [a.line,a.city,a.state,a.zip,a.span].join('|');
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  return all;
}
function getRelatives(detail){
  const rel = detail?.['All Relatives'] || detail?.Relatives || [];
  if (!Array.isArray(rel)) return [];
  return rel.map(r => ({
    name: firstNonEmpty(r.Name, r.name, recName(r)),
    relation: firstNonEmpty(r.relation, r.Relation)
  })).filter(r => r.name);
}
function getSummary(detail){
  const pd = Array.isArray(detail?.['Person Details']) ? detail['Person Details'][0] : null;
  const name = firstNonEmpty(pd?.Person_name, pd?.Name, detail?.Name, detail?.FullName);
  const age  = firstNonEmpty(pd?.Age, detail?.Age, detail?.age);
  const dob  = firstNonEmpty(pd?.Born, detail?.DOB, detail?.dob, detail?.DateOfBirth);
  return { name, age, dob, aka: [] };
}
const beginProgress = () => {
  setProgress(0);
  setPhase('Scraping feed…');
  startTs.current = Date.now();

  // 45 seconds per lead
  expectedMsRef.current = Math.max(1, Number(target) || 1) * 35000;

  if (progressTimer.current) clearInterval(progressTimer.current);
  progressTimer.current = setInterval(() => {
    const elapsed = Date.now() - startTs.current;
    const pct = Math.min(99, Math.floor((elapsed / expectedMsRef.current) * 100));
    setProgress(pct);

    if (pct < 10) setPhase('Starting Up');
    else if (pct < 25) setPhase('Launching Facebook instance');
    else if (pct < 75) setPhase('Vetting leads…');
    else if (pct < 95) setPhase('Pulling details…');
    else setPhase('Finalizing…');

    const remaining = Math.max(0, expectedMsRef.current - elapsed);
    const s = Math.ceil(remaining / 1000);
    setEta(s ? `${s}s left` : '');
  }, 200);
};
const endProgress = ({ force = false } = {}) => {
  const finish = () => {
    if (progressTimer.current) clearInterval(progressTimer.current);
    setProgress(100);
    setPhase('Done');
    setEta('');
    setLoading(false); // <-- close the modal here
  };

  if (force) {
    // Smoothly ramp to 100% then close quickly
    const startPct = Math.min(99, Number(progress) || 0);
    const startAt = Date.now();
    const duration = 400; // ms

    if (progressTimer.current) clearInterval(progressTimer.current);
    progressTimer.current = setInterval(() => {
      const t = Math.min(1, (Date.now() - startAt) / duration);
      const pct = Math.floor(startPct + (100 - startPct) * t);
      setProgress(pct);
      if (t >= 1) {
        clearInterval(progressTimer.current);
        finish();
      }
    }, 50);

    return; // don’t wait any longer
  }

  // If not forced, honor the remaining simulated time
  const elapsed = Date.now() - startTs.current;
  const remaining = Math.max(0, (expectedMsRef.current || 0) - elapsed);
  if (remaining > 0) {
    setTimeout(finish, remaining);
  } else {
    finish();
  }
};
  // Decorate posts with platform/market/type/capturedAt + tag chips
const decorate = (arr) => {
  const nowIso = new Date().toISOString();

  return (arr || []).map(p => {
    const baseTags = Array.isArray(p.tags) ? p.tags.slice() : [];

    // use the selected state/market from picker
    const detected = detectMarkets(p.text || '');
  const allMarkets = [];

   const finalMarkets = [...new Set([
     p?.meta?.market || '',   // prefer backend market
     ...detected
   ].filter(Boolean))];
    const extra = [
      SRC_FACEBOOK,
      ...allMarkets.map(m => marketTag(m)),
      typeTag(campaignType || 'Wholesale'),
      capturedTag(nowIso),
    ];

   const backendCaptured = p?.meta?.capturedAt; // ms epoch
   const captured = backendCaptured ?? nowIso;
   const market = p?.meta?.market || finalMarkets[0] || p.market || 'Unassigned';
   const type = p?.meta?.type || p.type || campaignType || 'Wholesale';

   return {
     ...p,
     platform: p?.meta?.source || p.platform || 'facebook',
     markets: finalMarkets,
     market,
     type,
     capturedAt: captured,
     tags: dedupeTagObjs([
       ...baseTags,
       SRC_FACEBOOK,
       ...finalMarkets.map(m => marketTag(m)),
       typeTag(type),
       capturedTag(
         typeof captured === 'number' ? new Date(captured).toISOString() : captured
       ),
     ]),
   };
  });
};

  const dedupeTagObjs = (tags=[]) => {
    const seen = new Set();
    const out = [];
    for (const t of tags) {
      const id = t?.id || `${t?.label || ''}`.toLowerCase();
      if (seen.has(id)) continue;
      seen.add(id);
      out.push(t);
    }
    return out;
  };
const refreshLogs = async () => {
  setLogsLoading(true); setLogsError('');
  try {
    await loadLogsWithCounts();
  } catch (e) {
    setLogsError(e?.message || String(e));
  } finally {
    setLogsLoading(false);
  }
};
const handleScrape = async () => {
  if (!keyword.trim() || handleScrape._busy) return;

  handleScrape._busy = true;
  setLoading(true);
  setPosts([]);
  setError('');
  setSource('live');
  beginProgress();

  // close any prior live listeners
  detachScrapeListeners?.();

  const base = devMode ? DEV_BASE : PROD_BASE;
  let path;
  if (campaignType === 'NextDoor') {
    path = '/nextdoor-scrapes';
  } else if (campaignType === 'Tree Service') {
    path = devMode ? '/tree-scrape' : '/tree-scrapes';
  } else {
    path = devMode ? DEV_PATH : PROD_PATH;
  }

  const url = `${base}${path}`;
  const isNextdoor = String(campaignType || '').toLowerCase() === 'nextdoor';

 // Normalize the UI selection into a clean subtype string (e.g., "Roofing")
 // Handles cases where nextdoorSubtype might be an object from a <Select/>.
 const rawSubtype =
   typeof nextdoorSubtype === 'string'
     ? nextdoorSubtype
     : (nextdoorSubtype?.value || nextdoorSubtype?.label || '');

 const cleanSubtype = rawSubtype
   .toString()
   .replace(/^nextdoor\s*[-–]\s*/i, '') // drop leading "Nextdoor - "
   .trim();
  const clientScrapeId = uuidv4();
  const payload = {
    keyword,
    // For Nextdoor we usually hide “Market”; send a stable label so logs look consistent.
    state: isNextdoor ? 'NextDoor' : (nationwide ? 'Nationwide' : (state === 'DMV' ? 'DMV' : state)),
    type: campaignType,
    limit: Number(target) || 40,
    automated: false,
    scrapeId: clientScrapeId,
   ...(isNextdoor ? { subtype: cleanSubtype, dateFilter: ndDateFilter } : {}),
  };
   console.log('[handleScrape] payload →', payload);

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-idempotency-key': clientScrapeId,
      },
      body: JSON.stringify(payload),
    });

    const raw = await res.text();
    if (!res.ok) {
      setError(`HTTP ${res.status} ${raw || ''}`);
      return;
    }

    let data;
    try { data = JSON.parse(raw); }
    catch { setError('Response was not JSON'); return; }

    const serverScrapeId = data?.scrapeId || clientScrapeId;

    // open progress modal
    openScrapeModal(serverScrapeId);

    // stream meta + leads
    attachScrapeListeners(serverScrapeId, {
      onMeta: (meta) => {
        setScrapeMeta(meta);
        if (meta?.status === 'error' && meta?.error) setError(meta.error);
      },
      onLeads: (rows) => {
        // Helpers (safe even if you didn’t export the constants)
        const SRC_ND = { id: 'SRC_ND', label: 'nextdoor', color: '#DBEAFE' };
        const mkSubtypeTag = (s) => s ? ({
          id: `TYPE_ND_${String(s).toUpperCase().replace(/[^A-Z0-9]+/g,'_')}`,
          label: `Type · Nextdoor · ${s}`,
          color: '#c7d2fe'
        }) : null;

        const cleaned = dedupePosts(rows);
        const enriched = decorate(cleaned).map((p) => {
          const runSubtype = p.subtype || payload.subtype || null;
          const isNd = isNextdoor ||
                       String(p?.platform || '').toLowerCase() === 'nextdoor' ||
                       String(p?.typeId || '').toLowerCase() === 'nextdoor';

          // base enrichment you already do
          const base = {
            ...p,
            searchPhrase: keyword.trim(),
            searchMarket: payload.state,
            searchType: campaignType,
            scrapeId: serverScrapeId,
          };

          if (!isNd) return base;

          // force canonical Nextdoor fields so filters/chips work now
          const withNd = {
            ...base,
            platform: 'nextdoor',
            type: 'NextDoor',
            subtype: runSubtype || null,
          };

          // ensure tags contain SRC_ND and subtype tag
          const tags = Array.isArray(p.tags) ? [...p.tags] : [];
          if (!tags.some(t => String(t?.id).toUpperCase() === 'SRC_ND')) tags.push(SRC_ND);
          const st = mkSubtypeTag(runSubtype);
          if (st && !tags.some(t => String(t?.id) === st.id)) tags.push(st);
          withNd.tags = tags;

          return withNd;
        });

        setPosts(enriched);
      },
    });

    if (activeTab === 'logs') refreshLogs?.();

  } catch (err) {
    setError(err?.message || String(err));
  } finally {
    endProgress({ force: true });
    setLoading(false);
    handleScrape._busy = false;
  }
};

function parseNextdoorDateLabelRobust(label, now = new Date()) {
  if (!label) return null;

  const nowMs = now.getTime();

  // Normalize & strip a leading "Neighborhood · ..." if present
  let s = String(label)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/^.*?·\s*/, ''); // drop neighborhood prefix if present

  // Fast paths
  if (s === 'just now' || s === 'now' || s === 'today') return nowMs;
  if (s === 'yesterday') return nowMs - 24 * 60 * 60 * 1000;

  // --- Relative “X units ago” (with variations) ---
  // Examples: "4h ago", "10 hours ago", "45m ago", "2 days ago", "1 wk ago"
  // Also allow without "ago": "3h", "2 d", "1w"
  // minutes
  let m;
  if ((m = s.match(/^(\d+)\s*(m|min|mins|minute|minutes)(?:\s+ago)?$/))) {
    const n = parseInt(m[1], 10);
    return nowMs - n * 60 * 1000;
  }
  if ((m = s.match(/^(\d+)\s*(h|hr|hrs|hour|hours)(?:\s+ago)?$/))) {
    const n = parseInt(m[1], 10);
    return nowMs - n * 60 * 60 * 1000;
  }
  if ((m = s.match(/^(\d+)\s*(d|day|days)(?:\s+ago)?$/))) {
    const n = parseInt(m[1], 10);
    return nowMs - n * 24 * 60 * 60 * 1000;
  }
  if ((m = s.match(/^(\d+)\s*(w|wk|wks|week|weeks)(?:\s+ago)?$/))) {
    const n = parseInt(m[1], 10);
    return nowMs - n * 7 * 24 * 60 * 60 * 1000;
  }

  // “X units ago” with a space between number and unit
  if ((m = s.match(/^(\d+)\s+(minutes?|hours?|days?|weeks?)\s+ago$/))) {
    const n = parseInt(m[1], 10);
    const unit = m[2];
    const ms =
      /minute/.test(unit) ? n * 60 * 1000 :
      /hour/.test(unit)   ? n * 60 * 60 * 1000 :
      /day/.test(unit)    ? n * 24 * 60 * 60 * 1000 :
                            n * 7 * 24 * 60 * 60 * 1000; // weeks
    return nowMs - ms;
  }

  // --- Absolute short dates like “11 Oct”, “Oct 11” (any case) ---
  const monthMap = { jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11 };

  const dm = s.match(/^(\d{1,2})\s+([a-z]{3,})$/i);       // 11 Oct
  const md = s.match(/^([a-z]{3,})\s+(\d{1,2})$/i);       // Oct 11
  const mdy = s.match(/^([a-z]{3,})\s+(\d{1,2}),?\s+(\d{4})$/i); // Oct 11, 2024
  const dmy = s.match(/^(\d{1,2})\s+([a-z]{3,}),?\s+(\d{4})$/i); // 11 Oct 2024

  const makeDate = (year, monthIdx, day) => {
    const d = new Date(year, monthIdx, day, 12, 0, 0, 0);
    // If parsed future (e.g., "Dec 28" while we're in early Jan), roll back 1 year
    if (d.getTime() > nowMs) d.setFullYear(d.getFullYear() - 1);
    return d.getTime();
    };

  if (dm) {
    const day = parseInt(dm[1], 10);
    const monIdx = monthMap[dm[2].slice(0,3)];
    if (monIdx != null) return makeDate(now.getFullYear(), monIdx, day);
  }
  if (md) {
    const day = parseInt(md[2], 10);
    const monIdx = monthMap[md[1].slice(0,3)];
    if (monIdx != null) return makeDate(now.getFullYear(), monIdx, day);
  }
  if (mdy) {
    const monIdx = monthMap[mdy[1].slice(0,3)];
    const day = parseInt(mdy[2], 10);
    const year = parseInt(mdy[3], 10);
    if (monIdx != null) return new Date(year, monIdx, day, 12, 0, 0, 0).getTime();
  }
  if (dmy) {
    const day = parseInt(dmy[1], 10);
    const monIdx = monthMap[dmy[2].slice(0,3)];
    const year = parseInt(dmy[3], 10);
    if (monIdx != null) return new Date(year, monIdx, day, 12, 0, 0, 0).getTime();
  }

  // --- Try “Oct 20 at 3:45 PM” styles (best-effort) ---
  const mdTime = s.match(/^([a-z]{3,})\s+\d{1,2}.*$/i);
  if (mdTime) {
    const tryParse = Date.parse(s.replace(/ at /i, ' '));
    if (!Number.isNaN(tryParse)) {
      // If year was omitted, Date.parse may guess current year; adjust if future
      const d = new Date(tryParse);
      if (d.getTime() > nowMs) d.setFullYear(d.getFullYear() - 1);
      return d.getTime();
    }
  }

  return null; // unknown pattern
}

async function handleLoadSaved({ initial = false } = {}) {
  if (loadingMore) return;

  try {
    setLoadingMore(true);

    const collRef = collection(db, 'scrape1');

    // Prefer capturedAt (ms epoch or ISO); fallback to createdAt
    // If your project doesn’t have an index on capturedAt yet, create one when Firestore prompts.
    let q = query(collRef, orderBy('capturedAt', 'desc'), limit(PAGE_SIZE));
    if (!initial && pageCursor) {
      q = query(collRef, orderBy('capturedAt', 'desc'), startAfter(pageCursor), limit(PAGE_SIZE));
    }

    const snap = await getDocs(q);

    // Normalize the date field we’ll sort/render on
    const normed = snap.docs.map(d => {
      const data = d.data();
      const ts =
        (typeof data.capturedAt === 'number' && data.capturedAt) ||
        (data.capturedAt?.toDate && data.capturedAt.toDate().getTime()) ||
        (typeof data.createdAt === 'number' && data.createdAt) ||
        (data.createdAt?.toDate && data.createdAt.toDate().getTime()) ||
        (typeof data.meta?.capturedAt === 'number' && data.meta.capturedAt) ||
        (data.meta?.capturedAt?.toDate && data.meta.capturedAt.toDate().getTime()) ||
        (data.timestamp ? new Date(data.timestamp).getTime() : null);

      return {
        id: d.id,
        ...data,
        capturedAt: ts || Date.now(), // ensure we always have something sortable
      };
    });

    setPosts(prev => (initial ? normed : [...prev, ...normed]));

    // keep paging cursor
    const last = snap.docs[snap.docs.length - 1] || null;
    setPageCursor(last);
    setHasMore(normed.length === PAGE_SIZE);
  } catch (e) {
    // If there’s no index on capturedAt yet, quick fallback to createdAt
    if (/FAILED_PRECONDITION|PERMISSION_DENIED/.test(String(e))) {
      try {
        let q = query(collection(db, 'scrape1'), orderBy('createdAt', 'desc'), limit(PAGE_SIZE));
        if (!initial && pageCursor) {
          q = query(collection(db, 'scrape1'), orderBy('createdAt', 'desc'), startAfter(pageCursor), limit(PAGE_SIZE));
        }
        const snap = await getDocs(q);
        const normed = snap.docs.map(d => {
          const data = d.data();
          const ts =
            (data.createdAt?.toDate && data.createdAt.toDate().getTime()) ||
            (typeof data.createdAt === 'number' && data.createdAt) ||
            (typeof data.capturedAt === 'number' && data.capturedAt) ||
            (data.capturedAt?.toDate && data.capturedAt.toDate().getTime()) ||
            (data.timestamp ? new Date(data.timestamp).getTime() : null);
          return { id: d.id, ...data, capturedAt: ts || Date.now() };
        });
        setPosts(prev => (initial ? normed : [...prev, ...normed]));
        const last = snap.docs[snap.docs.length - 1] || null;
        setPageCursor(last);
        setHasMore(normed.length === PAGE_SIZE);
      } catch (e2) {
        setError(e2.message || String(e2));
      }
    } else {
      setError(e.message || String(e));
    }
  } finally {
    setLoadingMore(false);
  }
}

  const handleViewSavedLeads = async () => {
      setViewingScrapeId(null);       // 👈 back to global mode

    setLoading(true);
    setError('');
    setSource('saved');
    beginProgress();
    try {
      const rows = await loadSavedLeads(4000);
      setPosts(rows);
    } catch (e) {
      setError(`[Saved Leads] ${e?.message || e}`);
    } finally {
      endProgress();
      setLoading(false);
    }
  };

  const exportAllToCSV = async () => {
    try {
      // grab what's on screen and latest from Firestore, then de-dupe
      const fromScreen = Array.isArray(posts) ? posts : [];
      const fromDb = await loadFromFirestore();
      const combined = dedupePosts([...(fromScreen||[]), ...(fromDb||[])]);
      const csv = makeCSV(combined);
      const date = new Date().toISOString().slice(0,19).replace(/[:T]/g,'-');
      downloadBlob(`leads_${date}.csv`, csv);
    } catch (e) {
      console.error('CSV export failed:', e);
      setError(`CSV export failed: ${e?.message || e}`);
    }
  };

  const toggleHeart = async (post, e) => {
    e.stopPropagation();
    const key = makeKey(post);
    const next = new Set(savedKeys);
    try {
      if (next.has(key)) {
        await removeSavedLead(post);
        next.delete(key);
      } else {
        await saveLead(post);
        next.add(key);
      }
      try {
  await logEvent(post, next.has(key) ? 'saved' : 'unsaved', {});
  if (selected && leadKey(selected) === key) setTimeline(await fetchTimeline(selected));
} catch {}
      setSavedKeys(next);
    } catch (err) {
      console.warn('Heart toggle error:', err);
    }
  };

const openDetails = async (post) => {
  setSelected(post);
  setDetailsOpen(true);
  try {
    setTimelineLoading(true);
    const rows = await ensureCapturedEvent(post);
    setTimeline(rows);
  } finally {
    setTimelineLoading(false);
  }
};  const closeDetails = () => { setDetailsOpen(false); setSelected(null); };

  // Legend & Details state


  // ==================== Skip Trace state/UI ====================
  const [skipOpen, setSkipOpen] = useState(false);
  const [skipLoading, setSkipLoading] = useState(false);
  const [skipError, setSkipError] = useState('');
  const [skipMode, setSkipMode] = useState('byname'); // 'byname' | 'byaddress' | 'bynameaddress'
  const [skipQuery, setSkipQuery] = useState({ name: '', street: '', citystatezip: '' });
  const [skipResults, setSkipResults] = useState([]); // PeopleDetails[]
  const [skipPage, setSkipPage] = useState(1);
  const [logOpen, setLogOpen] = useState(false);
const [logLines, setLogLines] = useState([]);
const [logLoading, setLogLoading] = useState(false);
const [logError, setLogError] = useState('');
const [logScrapeId, setLogScrapeId] = useState(null);
  const [skipSelected, setSkipSelected] = useState(null); // chosen person record
  const [skipDetail, setSkipDetail] = useState(null);     // detailsbyID response object
// === Fake Dialer state ===
// tune this if you want 100, 200, etc.

const [callOpen, setCallOpen] = useState(false);
const [callNumber, setCallNumber] = useState('');
const [callStep, setCallStep] = useState(0); // 0: Dialing, 1: Ringing, 2: Connecting, 3: Connected
const [logViewer, setLogViewer] = useState({
  open: false,
  scrapeId: null,
  lines: [],
  loading: false,
  unsub: null,
});
const logEndRef = useRef(null);

const openLog = (scrapeId) => {
  setLogViewer((v) => ({ ...v, open: true, scrapeId, loading: true }));
};
const closeLog = () => {
  logViewer.unsub?.();
  setLogViewer({ open: false, scrapeId: null, lines: [], loading: false, unsub: null });
};
const PAGE_SIZE = 200;

useEffect(() => {
  if (!logViewer.open || !logViewer.scrapeId) return;

  // ✅ use the subcollection under scrapes/{scrapeId}/logs
  const q = query(
    collection(db, 'scrapes', logViewer.scrapeId, 'logs'),
    orderBy('ts', 'asc'),
    limit(1000)
  );

  const unsub = onSnapshot(q, (snap) => {
    const lines = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setLogViewer((v) => ({ ...v, lines, loading: false }));
  }, (err) => {
    console.error('logViewer error:', err);
    setLogViewer((v) => ({ ...v, loading: false }));
  });

  return unsub;
}, [logViewer.open, logViewer.scrapeId]);

useEffect(() => {
  if (logViewer.open) logEndRef.current?.scrollIntoView({ behavior: 'smooth' });
}, [logViewer.lines, logViewer.open]);
const callTimerRef = useRef(null);
const logUnsubRef = useRef(null);
const levelColor = (level) =>
  level === 'error' ? 'error' : level === 'debug' ? 'default' : 'success';

const openDialer = (rawNumber) => {
  const masked = phoneMask(rawNumber);
  setCallNumber(masked || rawNumber || '');
  setCallStep(0);
  setCallOpen(true);

  // log a call event
  if (selected) {
    logEvent(selected, 'call', { number: rawNumber }).then(async () => {
      setTimeline(await fetchTimeline(selected));
    }).catch(()=>{});
  }

  if (callTimerRef.current) clearInterval(callTimerRef.current);
  callTimerRef.current = setInterval(() => {
    setCallStep((s) => (s >= 3 ? (clearInterval(callTimerRef.current), 3) : s + 1));
  }, 1200);
};

const closeDialer = () => {
  if (callTimerRef.current) clearInterval(callTimerRef.current);
  setCallOpen(false);
  setCallNumber('');
  setCallStep(0);
};
// When the Details modal opens on a post, fetch once & cache by key
useEffect(() => {
  if (!detailsOpen || !selected) return;

  const key = makeKey(selected);

  if (aiSummaryCacheRef.current.has(key)) {
    setAiSummary(aiSummaryCacheRef.current.get(key));
    setAiSummaryLoading(false);
    setAiSummaryError('');
    return;
  }

  setAiSummary(null);
  setAiSummaryError('');
  setAiSummaryLoading(true);

  fetchAiLeadSummary(selected) // <-- wrapper that defaults to wholesale, uses tree for tree leads
    .then(async (sum) => {
      aiSummaryCacheRef.current.set(key, sum);
      setAiSummary(sum);
      try { await persistAiSummary(selected, sum); } catch (e) {}
    })
    .catch((err) => {
      setAiSummaryError((err && err.message) || 'Could not load AI summary');
    })
    .finally(() => setAiSummaryLoading(false));
}, [detailsOpen, selected]);
useEffect(() => {
  return () => { if (callTimerRef.current) clearInterval(callTimerRef.current); };
}, []);
  const prefillSkipTrace = (post) => {
    const name = guessNameFromAuthor(post?.author || '');
    const citystatezip = extractCityStateZip(post?.text || '');
    setSkipMode(citystatezip ? 'bynameaddress' : 'byname');
    setSkipQuery({ name, street: '', citystatezip });
    setSkipResults([]);
    setSkipSelected(null);
    setSkipDetail(null);
    setSkipError('');
  };

  const handleOpenSkipTrace = () => {
    if (selected) prefillSkipTrace(selected);
    setSkipOpen(true);
  };
  const handleCloseSkipTrace = () => { setSkipOpen(false); };

  const doSkipSearch = async (page=1) => {
    setSkipLoading(true);
    setSkipError('');
    setSkipResults([]);
    setSkipSelected(null);
    setSkipDetail(null);
    try {
      const data = await skipTraceSearch({
        mode: skipMode,
        name: skipQuery.name,
        street: skipQuery.street,
        citystatezip: skipQuery.citystatezip,
        page,
      });
      setSkipResults(Array.isArray(data?.PeopleDetails) ? data.PeopleDetails : []);
      setSkipPage(Number(data?.Page || page));
    } catch (e) {
      setSkipError(e?.message || String(e));
    } finally {
      setSkipLoading(false);
    }
  };

  const getDetailsFor = async (rec) => {
    setSkipSelected(rec);
    setSkipDetail(null);
    setSkipLoading(true);
    setSkipError('');
    try {
      const id = rec?.['Person ID'] || rec?.PersonID || rec?.id;
      if (!id) throw new Error('Missing Person ID');
      const data = await skipTraceDetailsById(id);
      setSkipDetail(data);
    } catch (e) {
      setSkipError(e?.message || String(e));
    } finally {
      setSkipLoading(false);
    }
  };

  // Review dialog state
  const [reviewOpen, setReviewOpen] = useState(false);
  const [reviewVerdict, setReviewVerdict] = useState(null); // 'up' | 'down'
  const [reviewReason, setReviewReason] = useState('');
  const [reviewSubmitting, setReviewSubmitting] = useState(false);

  const openReview = (verdict) => {
    setReviewVerdict(verdict);         // 'up' or 'down'
    setReviewReason('');
    setReviewOpen(true);
  };
  const closeReview = () => {
    setReviewOpen(false);
    setReviewVerdict(null);
    setReviewReason('');
  };
const submitReview = async () => {
  if (!selected) return;

  const reason = reviewReason.trim();
  if (!reason) {
    setError('Please enter a reason.');
    return;
  }

  try {
    setReviewSubmitting(true);

    // 1) Persist the review in Firestore (your existing path)
    await saveReview(selected, reviewVerdict, reason);

    // 2) Update timeline (non-blocking if it fails)
    try {
      await logEvent(
        selected,
        reviewVerdict === 'up' ? 'review_up' : 'review_down',
        { reason }
      );
      setTimeline(await fetchTimeline(selected));
    } catch {
      /* soft-fail */
    }

    // 3) Send feedback to backend learner (single, canonical call)
    await sendFeedbackToBackend(selected, reviewVerdict, reason);

    // 4) Close the dialog
    closeReview();
  } catch (e) {
    setError(e?.message || String(e));
  } finally {
    setReviewSubmitting(false);
  }
};

  // === Filters & sorting ===

const markets = [
  'All',
  'Ohio',
  'Washington, DC',
  'Tennessee',
  'Maryland',
  'Virginia',
  'DMV',
];
const filteredSorted = React.useMemo(() => {
  // --- helpers (scoped to this memo) ---
  const toTs = (v) => {
    if (!v && v !== 0) return 0;
    const n = Number(v);
    if (!Number.isNaN(n) && n > 0) return n;
    const t = new Date(v).getTime();
    return Number.isNaN(t) ? 0 : t;
  };

  const getPostTimeMs = (r) => {
    // prefer capturedAt (our ingestion time), fall back to meta.capturedAt, then FB timestamp
    if (r.capturedAt) return toTs(r.capturedAt);
    if (r.meta && r.meta.capturedAt) return toTs(r.meta.capturedAt);
    if (r.timestamp) return toTs(r.timestamp);
    return 0;
  };

  let rows = Array.isArray(posts) ? posts.slice() : [];

  // Hide reviewed leads except in thumbs_up/down sources
  if (source !== 'thumbs_up' && source !== 'thumbs_down') {
    rows = rows.filter((r) => !(r.review?.verdict));
  }

  // Type filter
if (filterType !== 'All') {
  const want = String(filterType).toLowerCase();
  rows = rows.filter((r) => {
    const t   = String(r?.type || '').toLowerCase();
    const src = String(r?.platform || r?.meta?.source || '').toLowerCase();
    const svc = String(r?.serviceType || '').toLowerCase();
    const tagIds = Array.isArray(r?.tags) ? r.tags.map(x => String(x?.id || '').toLowerCase()) : [];

    if (want === 'nextdoor') {
      // Accept any of these signals
      return (
        t === 'nextdoor' ||
        src === 'nextdoor' ||
        tagIds.includes('type:nextdoor') ||
        tagIds.includes('src_nd') // older tag we set
      );
    }

    // Wholesale = pre-distress seller leads from NOVA Nextdoor scrapes.
    // Matches the new serviceType="Wholesale" tag, plus any legacy
    // type-based or tag-based wholesale flagging.
    if (want === 'wholesale') {
      return (
        svc === 'wholesale' ||
        t   === 'wholesale' ||
        tagIds.includes('svc:wholesale') ||
        tagIds.includes('vert:wholesale')
      );
    }

    return t === want;
  });
}

  // Market filter
  if (filterMarket !== 'All') {
    const normFilter = String(filterMarket).toLowerCase();

    rows = rows.filter((r) => {
      // explicit market field
      if (r.market && String(r.market).toLowerCase().includes(normFilter)) return true;

      // markets array
      if ((r.markets || []).some((m) => m && String(m).toLowerCase().includes(normFilter))) return true;

      // tags (by label)
      if ((r.tags || []).some((t) => String(t?.label || '').toLowerCase().includes(normFilter))) return true;

      return false;
    });
  }

  // Score filters
  const minO = Number(minOwner);
  const maxP = Number(maxProspector);
  if (!Number.isNaN(minO) && String(minOwner) !== '') {
    rows = rows.filter((r) => Number(r.ownerScore || 0) >= minO);
  }
  if (!Number.isNaN(maxP) && String(maxProspector) !== '') {
    rows = rows.filter((r) => Number(r.prospectorScore || 0) <= maxP);
  }

  // Date window filter (set by your "Fetch by Date" button)
  if (activeDateWindow && activeDateWindow.startMs && activeDateWindow.endMs) {
    const { startMs, endMs } = activeDateWindow;
    rows = rows.filter((r) => {
      const t = getPostTimeMs(r);
      if (!t) return false;
      return t >= startMs && t <= endMs;
    });
  }

  // Sorting
  if (sortBy === 'relevant') {
    rows.sort((a, b) => {
      const ao = Number(a.ownerScore || 0), bo = Number(b.ownerScore || 0);
      const ap = Number(a.prospectorScore || 0), bp = Number(b.prospectorScore || 0);
      if (bo !== ao) return bo - ao;      // higher ownerScore first
      if (ap !== bp) return ap - bp;      // lower prospectorScore first
      return getPostTimeMs(b) - getPostTimeMs(a); // newer first as tie-break
    });
  } else {
    // Most recent
    rows.sort((a, b) => getPostTimeMs(b) - getPostTimeMs(a));
  }

  return rows;
}, [
  posts,
  source,
  filterType,
  filterMarket,
  minOwner,
  maxProspector,
  sortBy,
  activeDateWindow, // ⬅ important for date filtering
]);
  // Tags in details modal — greens vs reds
    const isLCSelected = useMemo(() => {
    const t = (selected?.type || '').toLowerCase();
    if (t === 'lawncare' || t === 'landscaping') return true;
    return (selected?.tags || []).some(tag => /^LC/.test(tag?.id || ''));
  }, [selected]);
  const isRoofingSelected = useMemo(() => {
  const t = (selected?.type || '').toLowerCase();
  if (t === 'roofing') return true;
  return (selected?.tags || []).some(tag => /^RT/.test(tag?.id || ''));
}, [selected]);


const isTreeServiceSelected = String(filterType || campaignType).toLowerCase() === 'tree service';
const ownerTags = useMemo(() => {
  const tags = selected?.tags || [];

  if (isLCSelected) {
    // Lawncare “need” signals (show all LC* except vendor)
    return tags.filter(t => /^LC(?!V)/.test(t.id));
  }

  if (isRoofingSelected) {
    // Roofing “buyer” signals: all RT* except RTV/RTX (vendor/spam)
    return tags.filter(t => /^RT(?!V|X)/.test(t.id));
  }

  if (isTreeServiceSelected) {
    // Tree Service “need” signals: all TS* except TSV (vendor)
    return tags.filter(t => /^TS(?!V)/.test(t.id));
  }

  // Wholesale / default
  return tags.filter(t => /^(D\d+|DOV|R)$/.test(t.id));
}, [selected, isLCSelected, isRoofingSelected, isTreeServiceSelected]);

const prospectorTags = useMemo(() => {
  const tags = selected?.tags || [];

  if (isLCSelected) {
    // Lawncare vendor
    return tags.filter(t => /^LCV$/.test(t.id));
  }

if (isRoofingSelected) {
  // Roofing vendor/spam only
  return tags.filter(t => /^RT(V|X)$/.test(t.id));
}

if (isTreeServiceSelected) {
  // Tree Service vendor only
  return tags.filter(t => /^TSV$/.test(t.id));
}

// Wholesale / default
return tags.filter(t => /^(B\d+|B0|N\d+|REVIEW)$/.test(t.id));
}, [selected, isLCSelected, isRoofingSelected, isTreeServiceSelected]);


  const extraTags = useMemo(() => (selected?.tags || []).filter(t => /^(SRC_|MKT_|TYPE_|CAP_)/.test(t.id)), [selected]);

  const setSelected = (p) => setSelectedState(p);

  return (
    
    <Box sx={{ backgroundColor: '#f9fafb', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2, py: 4 }}>
      {/* Header */}
      {/* === Centered Leads / Logs toggle === */}
<Box
  sx={{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
    mt: 2,
    mb: 2,
  }}
>
  <Button
    variant={activeTab === 'leads' ? 'contained' : 'outlined'}
    color="primary"
    onClick={() => setActiveTab('leads')}
  >
    Leads
  </Button>
  <Button
    variant={activeTab === 'logs' ? 'contained' : 'outlined'}
    color="primary"
    onClick={() => { setActiveTab('logs'); refreshLogs(); }}
  >
    Logs
  </Button>
</Box>
{activeTab === 'logs' && (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: '100vh',
      pt: 4,
      width: '100%',
    }}
  >
    {/* === Centered Logo === */}
    <Box
      component="img"
      src={logo}
      alt="Logo"
      sx={{ height: 60, objectFit: 'contain', mb: 3 }}
    />

    {/* ======= Scheduled (upcoming) scrapes — dummy data ======= */}
   {(() => {
  // === HARD-CODED from gcloud output ===
const RAW_SCHEDULED = [
  {
    id: "brad-00-md-baltimore-sell-house",
    scheduleTime: "2025-10-16T19:40:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I'm looking to sell my house in Baltimore, Maryland","state":"Maryland","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-100-va-woodbridge-sell-house",
    scheduleTime: "2025-10-15T21:20:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I need to sell my house in Woodbridge, Virginia","state":"Virginia","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-120-md-gaithersburg-sell-house",
    scheduleTime: "2025-10-15T21:40:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I am selling my house in Gaithersburg, Maryland","state":"Maryland","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-140-va-reston-sell-house",
    scheduleTime: "2025-10-15T22:00:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I have to sell my house in Reston, Virginia","state":"Virginia","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-160-md-columbia-sell-house",
    scheduleTime: "2025-10-15T22:20:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I'm looking to sell my house in Columbia, Maryland","state":"Maryland","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-180-va-herndon-sell-house",
    scheduleTime: "2025-10-15T22:40:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I need to sell my house in Herndon, Virginia","state":"Virginia","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-20-va-alexandria-sell-house",
    scheduleTime: "2025-10-16T20:00:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I need to sell my house in Alexandria, Virginia","state":"Virginia","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-200-md-bethesda-sell-house",
    scheduleTime: "2025-10-15T23:00:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I am selling my house in Bethesda, Maryland","state":"Maryland","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-220-va-ashburn-sell-house",
    scheduleTime: "2025-10-15T23:20:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I have to sell my house in Ashburn, Virginia","state":"Virginia","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-240-md-annapolis-sell-house",
    scheduleTime: "2025-10-15T23:40:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I'm looking to sell my house in Annapolis, Maryland","state":"Maryland","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-40-md-silver-spring-sell-house",
    scheduleTime: "2025-10-16T20:20:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I am selling my house in Silver Spring, Maryland","state":"Maryland","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-60-va-fairfax-sell-house",
    scheduleTime: "2025-10-15T20:40:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I have to sell my house in Fairfax, Virginia","state":"Virginia","type":"Brad Lead","limit":200,"automated":true}
  },
  {
    id: "brad-80-md-bowie-sell-house",
    scheduleTime: "2025-10-15T21:00:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I'm looking to sell my house in Bowie, Maryland","state":"Maryland","type":"Brad Lead","limit":200,"automated":true}
  },

  {
    id: "nightly-scrape",
    scheduleTime: "2025-10-15T21:30:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"selling my home estate sale","state":"DMV","type":"Wholesale","limit":10,"automated":true}
  },
  {
    id: "scrape-dc-520pm-central",
    scheduleTime: "2025-10-15T22:20:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"Selling my house home","state":"Washington, DC","type":"Wholesale","limit":50,"automated":true}
  },

  {
    id: "sellhome-0230",
    scheduleTime: "2025-10-16T07:30:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I need to sell my home","state":"Nationwide","type":"Wholesale","limit":20,"automated":true}
  },
  {
    id: "sellhouse-1935",
    scheduleTime: "2025-10-16T00:35:00Z",
    timeZone: "America/Chicago",
    status: "scheduled",
    body: {"keyword":"I need to sell my house","state":"Nationwide","type":"Wholesale","limit":10,"automated":true}
  }
];

  const scheduled = RAW_SCHEDULED
    .map(j => ({
      id: j.id,
      time: new Date(j.scheduleTime),
      keyword: j.body.keyword,
      market: j.body.state,
      type: j.body.type,
      target: j.body.limit,
      automated: !!j.body.automated,
      status: j.status || 'scheduled',
    }))
    .sort((a,b) => a.time - b.time); // soonest first

  return (
    <Container
      maxWidth={false}
      sx={{ width:'100%', px:{ xs:2, md:4 }, mb:3, display:'flex', flexDirection:'column' }}
    >
      <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1.5 }}>
        <Typography variant="h6">Scheduled Scrapes</Typography>
        <Typography variant="body2" color="text.secondary">
          {`${scheduled.length} upcoming`}
        </Typography>
      </Box>

      <Paper elevation={2} sx={{ p:{ xs:1.5, md:2 }, borderRadius:2, background:'#fff' }}>
        {scheduled.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No upcoming scrapes found.
          </Typography>
        ) : (
          <Stack spacing={1.25}>
            {scheduled.map((row) => {
              const t = row.time
                ? row.time.toLocaleTimeString([], { hour:'numeric', minute:'2-digit' })
                : '—';

              const meta = (() => {
                const s = String(row.status || '').toLowerCase();
                if (s === 'running') return { chipBg:'#FEF3C7', chipColor:'#7c2d12', label:'Running' };
                if (s === 'error')   return { chipBg:'#FEE2E2', chipColor:'#7f1d1d', label:'Error' };
                return { chipBg:'#DBEAFE', chipColor:'#0b3b8b', label:'Scheduled' };
              })();

              return (
                <Box
                  key={row.id}
                  sx={{
                    border:'1px solid #e5e7eb',
                    borderRadius:2,
                    p:1.25,
                    backgroundColor:'#fff',
                    display:'flex',
                    alignItems:'center',
                    gap:1,
                    flexWrap:'wrap',
                  }}
                >
                  <Chip size="small" label={t} sx={{ bgcolor:'#eef2ff', color:'#1f2937', fontWeight:700 }} />
                  <Chip size="small" label={meta.label} sx={{ bgcolor:meta.chipBg, color:meta.chipColor, fontWeight:700 }} />

                  <Typography
                    variant="subtitle2"
                    sx={{ ml:1, minWidth:0, flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}
                    title={row.keyword}
                  >
                    “{row.keyword || '—'}”
                  </Typography>

                  <Stack direction="row" spacing={0.75} sx={{ flexWrap:'wrap' }}>
                    <Chip size="small" label={row.market} sx={{ bgcolor:'#fde68a', fontWeight:700 }} />
                    <Chip size="small" label={row.type}   sx={{ bgcolor:'#e9d5ff', fontWeight:700 }} />
                    <Chip size="small" label={`${row.target} leads`} sx={{ bgcolor:'#e5e7eb', fontWeight:700 }} />
                    {!!row.automated && <Chip size="small" label="Automated" sx={{ bgcolor:'#DBEAFE', fontWeight:700 }} />}
                  </Stack>
                </Box>
              );
            })}
          </Stack>
        )}
      </Paper>
    </Container>
  );
})()}

    {/* ======= Main: Scrape Logs (FULL WIDTH) ======= */}
    <Container
      maxWidth={false}
      sx={{
        width: '100%',
        px: { xs: 2, md: 4 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          mb: 2,
        }}
      >
        
      </Box>

      {!!logsError && <Typography color="error" sx={{ mb: 1 }}>{logsError}</Typography>}

      {/* ─────────────── SCRAPE LOGS ─────────────── */}
<Box sx={{ my: 3 }}>
  {/* Header row: title left, refresh right */}
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
    <Typography variant="h6" fontWeight={700}>Scrape Logs</Typography>
    <Button size="small" variant="outlined" onClick={refreshLogs}>Refresh</Button>
  </Box>

  {/* ===== Centered Toggle Row ===== */}
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      mb: 2,
    }}
  >
    <Box
      role="tablist"
      aria-label="Log type"
      sx={{
        display: 'inline-flex',
        borderRadius: 9999,
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        bgcolor: '#fff',
      }}
    >
      <Button
        role="tab"
        aria-selected={scrapeView === 'wholesale'}
        onClick={() => setScrapeView('wholesale')}
        size="small"
        sx={{
          px: 3,
          py: 1,
          borderRadius: 0,
          fontWeight: 600,
          textTransform: 'none',
          bgcolor: scrapeView === 'wholesale' ? '#111827' : 'transparent',
          color:   scrapeView === 'wholesale' ? '#fff'     : '#111827',
          '&:hover': { bgcolor: scrapeView === 'wholesale' ? '#111827' : '#f3f4f6' },
        }}
      >
        Wholesale
      </Button>
      <Button
        role="tab"
        aria-selected={scrapeView === 'tree'}
        onClick={() => setScrapeView('tree')}
        size="small"
        sx={{
          px: 3,
          py: 1,
          borderRadius: 0,
          fontWeight: 600,
          textTransform: 'none',
          bgcolor: scrapeView === 'tree' ? '#065f46' : 'transparent',
          color:   scrapeView === 'tree' ? '#fff'     : '#111827',
          '&:hover': { bgcolor: scrapeView === 'tree' ? '#065f46' : '#f3f4f6' },
        }}
      >
        Tree Service
      </Button>
    </Box>
  </Box>

  {!!logsError && (
    <Typography color="error" sx={{ mb: 1 }}>
      {logsError}
    </Typography>
  )}
  {logsLoading && <LinearProgress sx={{ mb: 2, width: '100%' }} />}

  <Paper
    elevation={2}
    sx={{
      width: '100%',
      overflowX: 'auto',
      borderRadius: 2,
      bgcolor: '#fff',
    }}
  >
    <Table stickyHeader size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontWeight: 700, width: 120 }}>Type</TableCell>
          <TableCell sx={{ fontWeight: 700, width: 180 }}>Started</TableCell>
          <TableCell sx={{ fontWeight: 700, width: 220 }}>Keyword</TableCell>
          <TableCell sx={{ fontWeight: 700, width: 160 }}>Market</TableCell>
          <TableCell sx={{ fontWeight: 700, width: 120 }}>Scrape Type</TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>Target</TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>Total</TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>Passed</TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>Failed</TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>Duration</TableCell>
          <TableCell sx={{ fontWeight: 700, minWidth: 240 }}>Status</TableCell>
          <TableCell sx={{ fontWeight: 700, minWidth: 160 }}>Env</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {filteredScrapeLogs.map((row) => {
          const started = row.startedAt?.toDate
            ? row.startedAt.toDate()
            : row.startedAt
            ? new Date(row.startedAt)
            : null;
          const dur = Number(row.durationMs || 0);
          const durLabel = dur ? `${Math.floor(dur / 1000)}s` : '—';

          const isAuto =
            row.startedTag === 'Automated' ||
            String(row.type || '').toLowerCase() === 'automated';

          return (
            <TableRow
              key={row._id || row.id}
              hover
              sx={{ cursor: 'pointer' }}
              onClick={async () => {
                const id = row._id || row.id;
                setViewingScrapeId(id);
                setActiveTab('leads');

                setLoading(true);
                setError('');
                beginProgress();
                try {
                  const leads = await loadLeadsByScrape(id, 4000);
                  setPosts(leads);
                  setSource('firestore');
                } catch (e) {
                  setError(`[Logs → Leads] ${e?.message || e}`);
                } finally {
                  endProgress({ force: true });
                  setLoading(false);
                }
              }}
            >
              <TableCell>
                <Chip
                  size="small"
                  label={isAuto ? 'Automated' : 'Manual'}
                  sx={{
                    fontWeight: 700,
                    bgcolor: isAuto ? '#dcfce7' : '#e0f2fe',
                    color: isAuto ? '#166534' : '#075985',
                  }}
                />
              </TableCell>

              <TableCell>{started ? started.toLocaleString() : '—'}</TableCell>
              <TableCell sx={{ maxWidth: 220, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {row.keyword || '—'}
              </TableCell>
              <TableCell>{row.market || '—'}</TableCell>
              <TableCell>{row.type || '—'}</TableCell>
              <TableCell align="right">{row.target ?? '—'}</TableCell>
              <TableCell align="right">{row.total ?? 0}</TableCell>
              <TableCell align="right">{row.passed ?? 0}</TableCell>
              <TableCell align="right" sx={{ color: '#b91c1c' }}>
                {row.failed ?? 0}
              </TableCell>
              <TableCell align="right">{durLabel}</TableCell>

              <TableCell>
                {isAuto && (
                  <Chip
                    size="small"
                    label="Automated"
                    sx={{
                      mr: 1,
                      bgcolor: '#DBEAFE',
                      color: '#1e3a8a',
                      fontWeight: 700,
                      border: '1px solid #bfdbfe',
                    }}
                  />
                )}
                {statusEmoji(row.status)} {row.status}
                {row.error && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{
                      ml: 1,
                      maxWidth: 220,
                      display: 'inline-block',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      verticalAlign: 'middle',
                    }}
                  >
                    — {String(row.error)}
                  </Typography>
                )}
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ ml: 1 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    openLog(row._id || row.id);
                  }}
                >
                  View Log
                </Button>
              </TableCell>

              <TableCell
                sx={{
                  maxWidth: 160,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {row.env || '—'}
              </TableCell>
            </TableRow>
          );
        })}

        {scrapeLogs.length === 0 && !logsLoading && (
          <TableRow>
            <TableCell colSpan={12} align="center" sx={{ py: 2, color: '#6b7280' }}>
              No logs yet.
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </Paper>
</Box>
    </Container>
  </Box>

)}
      <Box sx={{ width: '100%', maxWidth: 1280, display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
       {activeTab === 'leads' && <Box component="img" src={logo} alt="Logo" sx={{ height: 54, objectFit: 'contain' }} /> }
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap:'wrap' }}>





{/* Logs view */}


{activeTab === 'leads' && (
  <>

          
<Tooltip title="Export Saved Leads (on screen)">
  <Button
    startIcon={<FileDownloadIcon />}
    variant="outlined"
    onClick={() => {
     if (!filteredSorted || filteredSorted.length === 0) {
       alert("Nothing to export — no rows match your current filters.");
        return;
      }
     const csv = makeCSV(filteredSorted);            // 👈 only what’s on screen
     const stamp = new Date().toISOString().slice(0,19).replace(/[:T]/g,'-');
     downloadBlob(`leads_filtered_${filteredSorted.length}_${stamp}.csv`, csv);
    }}
  >
    Export CSV
  </Button>
</Tooltip>

          <Tooltip title="See thumbs-up reviews">
            <Button onClick={async ()=>{
              setLoading(true); setError(''); setSource('thumbs_up'); beginProgress();
              try {
                const rows = await loadReviewBucket('up', 2000);
                setPosts(rows);
              } catch(e){ setError(`[Thumbs Up] ${e?.message||e}`); }
              finally { endProgress(); setLoading(false); }
            }}>
              👍 Thumbs Up
            </Button>
          </Tooltip>

          <Tooltip title="See thumbs-down reviews">
            <Button onClick={async ()=>{
              setLoading(true); setError(''); setSource('thumbs_down'); beginProgress();
              try {
                const rows = await loadReviewBucket('down', 2000);
                setPosts(rows);
              } catch(e){ setError(`[Thumbs Down] ${e?.message||e}`); }
              finally { endProgress(); setLoading(false); }
            }}>
              👎 Thumbs Down
            </Button>
          </Tooltip>

          <Tooltip title="View Saved Leads">
            <Button onClick={handleViewSavedLeads}>Saved Leads</Button>
          </Tooltip>
          {/* <Tooltip title="Load ALL scrapes from Firestore">
            <Button variant="outlined" onClick={handleLoadSaved}>Load All</Button>
          </Tooltip> */}
          <Tooltip title="Scoring legend">
            <IconButton onClick={() => setLegendOpen(true)} aria-label="legend">
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>
          {/* 🟢 NEW: Brad Leads quick view & export */}
<Tooltip title="View Brad Leads">
  <Button onClick={handleViewBradLeads}>Brad Leads</Button>
</Tooltip>

<Tooltip title="Export Brad Leads (with skip-trace)">
  <Button
    startIcon={<FileDownloadIcon />}
    variant="outlined"
    onClick={async ()=>{
      setLoading(true);
      try {
        const rows = await loadBradLeads(4000);
        const csv = makeBradCSV(rows);
        const stamp = new Date().toISOString().slice(0,19).replace(/[:T]/g,'-');
        downloadBlob(`brad_leads_${rows.length}_${stamp}.csv`, csv);
      } catch(e){
        setError(`Brad CSV export failed: ${e?.message || e}`);
      } finally {
        setLoading(false);
      }
    }}
  >
    Brad CSV
  </Button>
</Tooltip>






  </>
)}

        </Box>
      </Box>



      {/* Controls: run a scrape */}
      <Box sx={{ width:'100%', maxWidth:1280, display: 'flex', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center', mb: 1.5 }}>
       {activeTab === 'leads' && (
  <>
<Box
  sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start', // keeps left alignment
    gap: 0.5,
    mr: 2,
  }}
>
 <FormControlLabel
    control={<Switch checked={nationwide} onChange={(e)=>setNationwide(e.target.checked)} color="primary" />}
    label="Nationwide"
  />
  <FormControlLabel
    control={<Switch checked={devMode} onChange={(e)=>setDevMode(e.target.checked)} color="secondary" />}
    label="Dev mode"
  />
</Box>
  </>
)}


{/* Filters + controls (Nationwide, DevMode, etc.) */}
{activeTab === 'leads' && (
  <>
       <Autocomplete
  freeSolo
  disableClearable
  filterOptions={(x) => x}

  // CONTROL the popup so we can force-close it on select
  open={acOpen && Boolean(keyword.trim())}
  onOpen={() => setAcOpen(true)}
  onClose={() => setAcOpen(false)}

  options={aiSuggestions}
  getOptionLabel={(opt) => (typeof opt === 'string' ? opt : (opt?.term || ''))}
  isOptionEqualToValue={(o, v) =>
    (typeof o === 'string' ? o : o?.term) === (typeof v === 'string' ? v : (v?.term || ''))
  }

  onInputChange={(_e, newValue, reason) => {
    if (reason !== 'reset') setKeyword(newValue || '');
  }}

  // CLICK/ENTER on an option: set keyword + CLOSE + blur input
  onChange={(_e, value) => {
    const v = typeof value === 'string' ? value : (value?.term || '');
    if (v) setKeyword(v);
    setAcOpen(false);
    kwInputRef.current?.blur();
  }}

  loading={aiLoading}
  loadingText="Fetching AI ideas…"
  noOptionsText={
    aiError
      ? `AI error: ${aiError}`
      : keyword.trim()
      ? 'No AI suggestions'
      : 'Type to see AI suggestions'
  }

  slotProps={{
    popper: { sx: { zIndex: 1500 } },
    paper: {
      sx: {
        borderRadius: 2,
        boxShadow: 6,
        overflow: 'hidden',
        mt: .5,
        maxWidth: 'min(84vw, 820px)',   // wider so long phrases breathe
        '& .MuiAutocomplete-listbox': {
          p: .25,
          '& li': {
            borderRadius: 1.25,
            mx: .5,
            my: .25,
          },
          '& li.Mui-focused': {
            backgroundColor: '#eef2ff',
          }
        }
      }
    }
  }}

  renderOption={(props, sug) => {
    const term   = typeof sug === 'string' ? sug : (sug?.term || '');
    const up     = typeof sug === 'string' ? 1   : (sug?.thumbsUp ?? 0);
    const conf   = typeof sug === 'string' ? 0.6 : (sug?.score ?? 0.6);
    const reason = (typeof sug === 'object' && sug?.reason) ? String(sug.reason) : '';

    return (
      <li {...props} title={reason || term} style={{ padding: 10 }}>
        <Box sx={{ display:'flex', alignItems:'flex-start', gap: 1, width:'100%' }}>
          <AutoAwesomeIcon sx={{ fontSize: 18, color:'#6b7280', mt: '2px' }} />
          {/* TEXT — WRAPS (no cutoff) */}
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 700,
                color: '#111827',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
              }}
            >
              <Highlighted text={term} query={keyword} />
            </Typography>

            {!!reason && (
              <Typography
                variant="caption"
                sx={{
                  color: '#6b7280',
                  display: 'block',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  mt: .25
                }}
              >
                {reason}
              </Typography>
            )}
          </Box>

          <SuggestMeta thumbsUp={up} score={conf} />
        </Box>
      </li>
    );
  }}

  renderInput={(params) => (
    <TextField
      {...params}
      label="Keyword"
      size="small"
      variant="outlined"
      value={keyword}
      inputRef={kwInputRef}
      inputProps={{
        ...params.inputProps,
        onFocus: (e) => {
          params.inputProps?.onFocus?.(e);
          setAcOpen(true);
          if (keyword.trim() && aiSuggestions.length === 0 && !aiLoading) {
            // optional eager fetch
            requestAi?.();
          }
        },
        onBlur: params.inputProps?.onBlur,
      }}
      onChange={(e) => setKeyword(e.target.value)}
      sx={{ minWidth: 300 }}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            <AutoAwesomeIcon fontSize="small" sx={{ mr: .5, opacity: aiLoading ? 1 : .7 }} />
            {params.InputProps.endAdornment}
          </>
        ),
      }}
    />
  )}
/>


        {/* NEW: campaign type picker that becomes a tag */}
        <TextField
          select
          size="small"
          label="Type"
          value={campaignType}
          onChange={(e) => {
    const v = e.target.value;
    setCampaignType(v);
    if (String(v).toLowerCase() !== 'nextdoor') {
      setNextdoorSubtype('');
    }
  }}
  sx={{ minWidth: 180 }}
        >
          <MenuItem value="Wholesale">Wholesale</MenuItem>
          <MenuItem value="Refinance">Refinance</MenuItem>
          <MenuItem value="Roofing">Roofing</MenuItem>
            <MenuItem value="Scrape for Will">Scrape for Will</MenuItem>
          <MenuItem value="Lawncare">Lawncare</MenuItem>
            <MenuItem value="9/18 Scrapes">9/18 Scrapes</MenuItem> 
            <MenuItem value="9/19 Scrapes">9/19 Scrapes</MenuItem>
            <MenuItem value="10/2 Scrapes">10/2 Scrapes</MenuItem>
            <MenuItem value="9/19 Scrapes">9/29 Scrapes</MenuItem>
            <MenuItem value="10/3 Scrapes">10/3 Scrapes</MenuItem>
            <MenuItem value="10/7 Scrapes">10/7 Scrapes</MenuItem>
            <MenuItem value="10/9 Scrapes">10/9 Scrapes</MenuItem>
            <MenuItem value="Brad Leads">Brad Leads</MenuItem>
              <MenuItem value="Tree Service">Tree Service</MenuItem>
              <MenuItem value="Nextdoor">NextDoor</MenuItem>



        </TextField>
        {!isNextdoorSelected && (
  <TextField
    select
    size="small"
    label="Market (State or City/State)"
    value={state}
    disabled={nationwide}
    onChange={(e) => setState(e.target.value)}
    sx={{ minWidth: 220 }}
  >
    <MenuItem value="Ohio">Ohio</MenuItem>
    <MenuItem value="Washington, DC">Washington, DC</MenuItem>
    <MenuItem value="Tennessee">Tennessee</MenuItem>
    <MenuItem value="Maryland">Maryland</MenuItem>
    <MenuItem value="Virginia">Virginia</MenuItem>
    <MenuItem value="DMV">DMV (DC / Maryland / Virginia)</MenuItem>
    <MenuItem value="Tree Service">Tree Service</MenuItem>
    <MenuItem value="Nextdoor">NextDoor</MenuItem>
  </TextField>
)}
{isNextdoorSelected && (
  <>
  <TextField
    select
    size="small"
    label="Nextdoor subtype"
    value={nextdoorSubtype}
    onChange={(e)=> setNextdoorSubtype(e.target.value)}
    sx={{ minWidth: 240 }}
  >
    {/* optional header */}
    <ListSubheader>Nextdoor</ListSubheader>
    {NEXTDOOR_SUBTYPES.map(s => (
      <MenuItem key={s.value} value={s.value}>{s.value}</MenuItem>
    ))}
  </TextField>
   {String(campaignType || '').toLowerCase() === 'nextdoor' && (
    <FormControl size="small" sx={{ minWidth: 180 }}>
      <InputLabel>Post date</InputLabel>
      <Select
        label="Post date"
        value={ndDateFilter}
        onChange={(e) => setNdDateFilter(e.target.value)}
      >
        {ND_DATE_FILTERS.map(opt => (
          <MenuItem key={opt.key} value={opt.key}>{opt.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  )}
  </>
)}

        <TextField
          label="Leads"
          type="number"
          size="small"
          value={target}
          inputProps={{ min: 1, max: 1000 }}
          onChange={(e)=> {
            const n = Math.max(1, Math.min(1000, Number(e.target.value)||25));
            setTarget(n);
          }}
          sx={{ width: 120 }}
        />
       <Button
  variant="contained"
  onClick={handleScrape}
  disabled={!!handleScrape._busy}  
  sx={{ px: 3, height: 40 }}
>
  {handleScrape._busy ? 'Running…' : 'Run Scrape'}
</Button>
  </>
)}



      </Box>












{activeTab === 'leads' && (

     <>
      <Container maxWidth="lg" sx={{ mb: 2 }}>
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center', // 🔑 centers the whole row
      gap: 1.5,
      textAlign: 'center',
    }}
  >
    <FilterAltIcon sx={{ color: '#6b7280' }} />

    <FormControl size="small" sx={{ minWidth: 160 }}>
      <InputLabel>Filter Type</InputLabel>
      <Select
        label="Filter Type"
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="Wholesale">Wholesale</MenuItem>
        <MenuItem value="Scrape for Will">Scrape for Will</MenuItem>
        <MenuItem value="Refinance">Refinance</MenuItem>
           <MenuItem value="Roofing">Roofing</MenuItem>

        <MenuItem value="9/18 Scrapes">9/18 Scrapes</MenuItem>
        <MenuItem value="9/19 Scrapes">9/19 Scrapes</MenuItem>
        <MenuItem value="10/2 Scrapes">10/2 Scrapes</MenuItem>
                    <MenuItem value="9/19 Scrapes">9/29 Scrapes</MenuItem>
                    <MenuItem value="10/3 Scrapes">10/3 Scrapes</MenuItem>
                    <MenuItem value="10/7 Scrapes">10/7 Scrapes</MenuItem>
                    <MenuItem value="10/9 Scrapes">10/9 Scrapes</MenuItem>
        <MenuItem value="Lawncare">Lawncare</MenuItem>
        <MenuItem value="Brad Leads">Brad Leads</MenuItem>
          <MenuItem value="Tree Service">Tree Service</MenuItem>
          <MenuItem value="Nextdoor">NextDoor</MenuItem>

      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 180 }}>
      <InputLabel>Filter Market</InputLabel>
      <Select
        label="Filter Market"
        value={filterMarket}
        onChange={(e) => setFilterMarket(e.target.value)}
      >
        {markets.map((m) => (
          <MenuItem key={m} value={m}>
            {m}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <TextField
      size="small"
      label="Min Owner score"
      value={minOwner}
      onChange={(e) => setMinOwner(e.target.value)}
      sx={{ width: 150 }}
    />
    <TextField
      size="small"
      label="Max Prospector score"
      value={maxProspector}
      onChange={(e) => setMaxProspector(e.target.value)}
      sx={{ width: 180 }}
    />

    <SortIcon sx={{ color: '#6b7280' }} />
    <FormControl size="small" sx={{ minWidth: 170 }}>
      <InputLabel>Sort</InputLabel>
      <Select
        label="Sort"
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
      >
        <MenuItem value="recent">Most Recent</MenuItem>
        <MenuItem value="relevant">Most Relevant</MenuItem>
      </Select>
    </FormControl>
  </Box>

</Container>
<Container maxWidth="lg" sx={{ mb: 2 }}>
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1.2,
      p: 1,
      borderRadius: 2,
    }}
  >
    <FilterAltIcon sx={{ color: '#6b7280' }} />

    <FormControl size="small" sx={{ minWidth: 140 }}>
      <InputLabel>Date Filter</InputLabel>
      <Select
        label="Date Filter"
        value={dateMode}
        onChange={(e) => setDateMode(e.target.value)}
      >
        <MenuItem value="all">All time</MenuItem>
        <MenuItem value="single">Single day</MenuItem>
        <MenuItem value="range">Date range</MenuItem>
      </Select>
    </FormControl>

    {dateMode === 'single' && (
      <DatePicker
        label="Select date"
        value={dateSingle}
        onChange={(d) => setDateSingle(d)}
        slotProps={{ textField: { size: 'small' } }}
      />
    )}

    {dateMode === 'range' && (
      <DateRangePicker
        localeText={{ start: 'Start', end: 'End' }}
        value={dateRange}
        onChange={(v) => setDateRange(v)}
        slotProps={{ textField: { size: 'small' } }}
      />
    )}

    <Button
      variant="contained"
      onClick={handleFetchByDate}
      disabled={
        dateLoading ||
        (dateMode === 'single' && !dateSingle) ||
        (dateMode === 'range' && (!dateRange[0] || !dateRange[1]))
      }
    >
      {dateLoading ? 'Loading…' : 'Fetch by Date'}
    </Button>

    <Button
      variant="text"
      onClick={() => {
        setDateMode('all');
        setDateSingle(null);
        setDateRange([null, null]);
        setDateError('');
      }}
    >
      Clear
    </Button>

    {!!dateError && (
      <Typography variant="caption" color="error" sx={{ ml: 1 }}>
        {dateError}
      </Typography>
    )}
  </Box>
</Container>


<Typography variant="body2" color="text.secondary" mb={2}>
  Source: {source === 'live'
    ? `Live scrape → ${devMode ? DEV_BASE + DEV_PATH : PROD_BASE + PROD_PATH}`
    : ({
        'firestore': 'Firestore (all scrapes)',
        'saved': 'Saved Leads',
        'thumbs_up': 'Reviewed: Thumbs Up',
        'thumbs_down': 'Reviewed: Thumbs Down'
      }[source])
  }
</Typography>
{/* <FormGroup row>
  <FormControlLabel
    control={
      <Checkbox
        checked={showPast5DaysOnly}
        onChange={(e) => {
          // optional: make them mutually exclusive
          setShowPast5DaysOnly(e.target.checked);
          if (e.target.checked) {
            setShowPast2WeeksOnly(false);
            setShowRecentOnly(false);
          }
        }}
      />
    }
    label="Only show leads from past 5 days"
  />

  <FormControlLabel
    control={
      <Checkbox
        checked={showPast2WeeksOnly}
        onChange={(e) => {
          setShowPast2WeeksOnly(e.target.checked);
          if (e.target.checked) {
            setShowPast5DaysOnly(false);
            setShowRecentOnly(false);
          }
        }}
      />
    }
    label="Only show leads from past 2 weeks"
  />

  <FormControlLabel
    control={
      <Checkbox
        checked={showRecentOnly}
        onChange={(e) => {
          setShowRecentOnly(e.target.checked);
          if (e.target.checked) {
            setShowPast5DaysOnly(false);
            setShowPast2WeeksOnly(false);
          }
        }}
      />
    }
    label="Only show leads from past month"
  />
</FormGroup> */}

{!!error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}

<Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 2,
    flexWrap: 'wrap',
  }}
>
  <TextField
    size="small"
    placeholder="Search leads… (author or text)"
    value={leadSearch}
    onChange={(e) => setLeadSearch(e.target.value)}
    InputProps={{ sx: { bgcolor: '#fff' } }}
    sx={{ width: { xs: '100%', sm: 360 } }}
  />
  <Typography variant="body2" color="text.secondary" sx={{ ml: 'auto' }}>
    {loading
      ? 'Working…'
      : (() => {
          const q = norm(leadSearch).trim();
          const tokens = q.split(/\s+/).filter(Boolean);
          const matchesCount = tokens.length
            ? filteredSorted.filter(p => {
                const hay = textForSearch(p);
                return tokens.every(t => hay.includes(t));
              }).length
            : filteredSorted.length;
          return `Showing ${matchesCount} of ${posts.length} total`;
        })()
    }
  </Typography>
</Box>

{logsLoading && <LinearProgress sx={{ mb: 2, width: '100%' }} />}

{(() => {
// Minimal, resilient fallback for labels like "5h", "3d", "Yesterday", or real dates.
function parseRelativeOrDateLabel(label) {
  if (!label) return 0;
  const s = String(label).trim().toLowerCase();
  const now = Date.now();
  const MIN = 60 * 1000, HOUR = 60 * MIN, DAY = 24 * HOUR;

  if (s === 'just now') return now;
  if (s === 'yesterday') return now - DAY;

  // "5m", "5 min", "5 mins", "5 minutes"
  let m = s.match(/^(\d+)\s*(m|min|mins|minute|minutes)$/i);
  if (m) return now - Number(m[1]) * MIN;

  // "3h", "3 hr", "3 hrs", "3 hours"
  m = s.match(/^(\d+)\s*(h|hr|hrs|hour|hours)$/i);
  if (m) return now - Number(m[1]) * HOUR;

  // "2d", "2 day(s)"
  m = s.match(/^(\d+)\s*(d|day|days)$/i);
  if (m) return now - Number(m[1]) * DAY;

  // Try native Date parsing last
  const t = new Date(label).getTime();
  return Number.isNaN(t) ? 0 : t;
}

  // --- search tokens ---
  const q = norm(leadSearch).trim();
  const tokens = q.split(/\s+/).filter(Boolean);

  // NOTE: filterType already applied in filteredSorted (inside the big useMemo).
  // Use it as our base; do not re-filter type here.
  const base = filteredSorted;

  // --- constants for date filters (local to this block) ---
  const NOW = Date.now();
  const DAY = 24 * 60 * 60 * 1000;
  const FIVE_DAYS_MS   = 5 * DAY;
  const TWO_WEEKS_MS   = 14 * DAY;
  const ONE_MONTH_MS   = 30 * DAY;

  // --- helper: get a timestamp for date filtering (robust) ---
  const toTs = (v) => {
    if (!v && v !== 0) return 0;
    const n = Number(v);
    if (!Number.isNaN(n) && n > 0) return n;
    const t = new Date(v).getTime();
    return Number.isNaN(t) ? 0 : t;
  };
  const getPostTimeMsLoose = (p) => {
    // Prefer capturedAt/meta.capturedAt/timestamp
    const hard =
      toTs(p?.capturedAt) ||
      toTs(p?.meta?.capturedAt) ||
      toTs(p?.timestamp);
    if (hard) return hard;
    // Fallback to a simple label parser
    const label = p?.datePostedLabel || p?.timeLabel || '';
    return parseRelativeOrDateLabel(label);
  };

  // --- apply text search on base ---
  const textMatches = (p) => {
    if (!tokens.length) return true;
    const hay = textForSearch(p); // existing helper in your codebase
    return tokens.every((t) => hay.includes(t));
  };
  const afterSearch = base.filter(textMatches);

  // --- apply checkbox date windows ---
  const withinDateWindow = (p) => {
    if (!showPast5DaysOnly && !showPast2WeeksOnly && !showRecentOnly) return true;
    const ts = getPostTimeMsLoose(p);
    if (!ts) return false;
    const age = NOW - ts;
    if (showPast5DaysOnly)  return age <= FIVE_DAYS_MS;
    if (showPast2WeeksOnly) return age <= TWO_WEEKS_MS;
    if (showRecentOnly)     return age <= ONE_MONTH_MS;
    return true;
  };

  // This replaces the undefined `leadsToShow`
  const leadsToShow = afterSearch.filter(withinDateWindow);

  // This is what you actually render below
  const visiblePosts = leadsToShow;







  return (
    <>
      {/* Grid */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 2,
          width: '100%',
          maxWidth: 1280
        }}
      >
        {visiblePosts.map((post) => {
          const key = displayKey(post);
          const isSaved = savedKeys.has(key);
          const cap = post.capturedAt ? new Date(post.capturedAt).toLocaleString() : null;

          return (
            <Card
              key={key}
              sx={{
                borderRadius: 2,
                boxShadow: 2,
                cursor: 'pointer',
                transition: '0.15s',
                position: 'relative',
                '&:hover': { boxShadow: 4 },
              }}
              onClick={() => openDetails(post)}
            >
              {/* Heart */}
              <IconButton
                aria-label="save lead"
                onClick={(e) => toggleHeart(post, e)}
                sx={{ position: 'absolute', right: 6, top: 6, zIndex: 2 }}
              >
                {isSaved ? <FavoriteIcon color="error" /> : <FavoriteBorderIcon />}
              </IconButton>

              <CardContent sx={{ p: 1.5 }}>
                <Typography
                  fontWeight={700}
                  variant="subtitle1"
                  gutterBottom
                  sx={{
                    lineHeight: 1.2,
                    mb: 1,
                    pr: 4,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  title={post.author}
                >
                  {post.author}
                </Typography>
{(post.datePostedLabel || post.timeLabel) && (
    <Typography
      variant="caption"
      sx={{ display: 'block', color: 'text.secondary', mb: 1 }}
    >
      🕓 {post.datePostedLabel || post.timeLabel}
    </Typography>
  )}
                <Typography
                  variant="body2"
                  sx={{ mb: 1, display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
                  title={cleanFbNoise(post.text)}
                >
                  {cleanFbNoise(post.text) || 'No content found'}
                </Typography>

                <Stack direction="row" spacing={0.6} sx={{ flexWrap: 'wrap', alignItems:'center' }}>
                  {post.lang === 'es' && (
                    <Chip size="small" label="Spanish" sx={{ bgcolor:'#bfdbfe', color:'#0b3b8b', fontWeight:700 }} />
                  )}
                  <Chip
                    size="small"
                    label={`${isLawncarePost(post) ? 'Need' : 'Owner'} ${post.ownerScore ?? 0}`}
                    sx={{ bgcolor: chipStyles.owner.bg, color: chipStyles.owner.fg, fontWeight: 600 }}
                  />
                  <Chip
                    size="small"
                    label={`${isLawncarePost(post) ? 'Vendor' : 'Prospector'} ${post.prospectorScore ?? 0}`}
                    sx={{ bgcolor: chipStyles.prospector.bg, color: chipStyles.prospector.fg, fontWeight: 600 }}
                  />
                  {post.searchPhrase && (
                    <Tooltip title="Search phrase">
                      <Chip
                        size="small"
                        label={`“${post.searchPhrase.slice(0, 28)}${post.searchPhrase.length>28?'…':''}”`}
                        sx={{ bgcolor:'#eef2ff', color:'#1f2937', fontStyle:'italic', fontWeight:600, maxWidth: 220 }}
                      />
                    </Tooltip>
                  )}

                  <Chip
                    size="small"
                    label={(post.classification ?? 'uncertain')}
                    sx={{
                      bgcolor: (post.classification === 'homeowner' ? chipStyles.homeowner.bg : chipStyles.uncertain.bg),
                      color: (post.classification === 'homeowner' ? chipStyles.homeowner.fg : chipStyles.uncertain.fg),
                      textTransform: 'capitalize',
                      fontWeight: 700
                    }}
                  />

                  {/* NEW: source / market / type / capturedAt chips */}
                  <Chip size="small" label={post.platform || 'facebook'} sx={{ bgcolor:'#DBEAFE', color:'#111827', fontWeight:600 }} />
                  {post.market && <Chip size="small" label={post.market} sx={{ bgcolor:'#FDE68A', color:'#111827', fontWeight:600 }} />}
                  {post.type && <Chip size="small" label={post.type.toLowerCase()} sx={{ bgcolor:'#E9D5FF', color:'#111827', fontWeight:600 }} />}
                  {cap && <Chip size="small" label={cap} sx={{ bgcolor:'#E5E7EB', color:'#111827', fontWeight:600 }} />}

                  {(post.tags ?? [])
                    .filter(t => {
                      const id = t?.id || '';
                      if (isLawncarePost(post)) return /^LC/.test(id);
                      if (isTreeServicePost(post)) return /^TS/.test(id);
                      return !/^LC|^TS/.test(id);
                    })
                    .sort((a, b) => {
                      const W = { RTI:100, RTA:90, RTD:85, RTN:80, RT3:70, RT2:65, RT4:55, RTP:40, RT8:35, RTR:30,
                                  RTM:25, RTF:25, RTS:25, RTC:25, RTQ:20, RTB:15, 'RT$':15, RTH:10, RTV:-999, RTX:-998 };
                      const wa = W[a.id] ?? 0, wb = W[b.id] ?? 0;
                      return wb - wa;
                    })
                    .slice(0, 3)
                    .map(t => (
                      <Chip key={`${t.id}-${t.label}`} size="small" label={t.label} sx={{ bgcolor: t.color, color: '#0f172a' }} />
                    ))
                  }

                  {(post.timestamp || post.timeLabel) && (
                    <Chip
                      size="small"
                      label={post.timeLabel || new Date(post.timestamp).toLocaleString()}
                      sx={{ bgcolor: '#e5e7eb', color: '#111827', fontWeight: 600 }}
                    />
                  )}

                  {(post.verdict || post.reason) && (
                    <Tooltip title={post.reason || ''}>
                      <Chip
                        size="small"
                        label={
                          post.verdict === 'good'
                            ? '✅ Good Lead'
                            : post.verdict === 'medium'
                            ? '⚠️ Medium Lead'
                            : '❌ Rejected'
                        }
                        sx={{
                          bgcolor:
                            post.verdict === 'good'
                              ? '#d1fae5'
                              : post.verdict === 'medium'
                              ? '#fef9c3'
                              : '#fee2e2',
                          color: '#111827',
                          fontWeight: 700,
                        }}
                      />
                    </Tooltip>
                  )}

                  {bradKeys.has(makeKey(post)) && (
                    <Chip size="small" label="Brad" sx={{ bgcolor:'#d1fae5', color:'#065f46', fontWeight:700 }} />
                  )}
                </Stack>
              </CardContent>
            </Card>
          );
        })}
      </Box>

      <div ref={sentinelRef} style={{ height: 1 }} />

      {loadingMore && (
        <Typography align="center" variant="body2" sx={{ opacity: 0.7, py: 1 }}>
          Loading…
        </Typography>
      )}
      {!hasMore && !!posts.length && (
        <Typography align="center" variant="caption" sx={{ opacity: 0.7, py: 1 }}>
          No more results
        </Typography>
      )}

      {!loading && leadsToShow.length === 0 && !error && (
        <Typography variant="body2" color="text.secondary" mt={4}>
          No results match your filters (and search). Try clearing them or click “Load All”.
        </Typography>
      )}
    </>
  );
})()}







<Dialog open={scrapeModalOpen} onClose={closeScrapeModal} fullWidth maxWidth="sm">
  <DialogTitle>
    Scrape: {currentScrapeId || '—'}
  </DialogTitle>
  <DialogContent dividers>
    <Stack spacing={1}>
      <Typography variant="body2">
        Status: {scrapeMeta?.status || 'starting…'}
      </Typography>
      {scrapeMeta?.error && (
        <Typography variant="body2" color="error">
          {scrapeMeta.error}
        </Typography>
      )}
      <Typography variant="body2">
        Total leads: {Array.isArray(posts) ? posts.length : 0}
      </Typography>
      {/* add any progress bar, logs, etc. */}
    </Stack>
  </DialogContent>
  <DialogActions>
    <Button onClick={closeScrapeModal}>Close</Button>
  </DialogActions>
</Dialog>
      
<Dialog open={logOpen} onClose={closeScrapeLogDialog} maxWidth="md" fullWidth>
  <DialogTitle sx={{ pr: 6 }}>
    Scrape Log — {logScrapeId || ''}
    <IconButton onClick={closeScrapeLogDialog} sx={{ position:'absolute', right:8, top:8 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers sx={{ bgcolor:'#0b1020', p:0 }}>
    {logLoading && <LinearProgress />}
    {!!logError && <Box sx={{ color:'#fecaca', p:2 }}>{logError}</Box>}

    <Box sx={{
      fontFamily:'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      fontSize: 13,
      lineHeight: 1.4,
      color:'#e5e7eb',
      p: 2,
      maxHeight: 480,
      overflow:'auto',
      whiteSpace: 'pre-wrap',
    }}>
      {logLines.length === 0 && !logLoading ? (
        <Typography variant="body2" sx={{ color:'#a1a1aa' }}>No log lines yet.</Typography>
      ) : (
        logLines.map(l => {
          const t = l.ts?.toDate ? l.ts.toDate().toLocaleTimeString() : '…';
          const lvl = String(l.level || 'info').toUpperCase().padEnd(5,' ');
          const color =
            l.level === 'error' ? '#fecaca' :
            l.level === 'warn' ? '#fde68a' : '#c7d2fe';
          const meta = l.meta ? ` ${JSON.stringify(l.meta).slice(0,300)}` : '';
          return (
            <div key={l.id} style={{ color }}>
              [{t}] {lvl} — {l.msg}{meta}
            </div>
          );
        })
      )}
    </Box>
  </DialogContent>

  <DialogActions>
    <Button onClick={closeScrapeLogDialog} variant="contained">Close</Button>
  </DialogActions>
</Dialog>
      {/* Legend Modal */}
      <Dialog open={legendOpen} onClose={() => setLegendOpen(false)} maxWidth="md" fullWidth>
  <DialogTitle sx={{ pr: 6 }}>
    Scoring & Tags Legend
    <IconButton onClick={() => setLegendOpen(false)} sx={{ position: 'absolute', right: 8, top: 8 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    {(() => {
      const lc =
        String(filterType || '').toLowerCase() === 'lawncare' ||
        String(campaignType || '').toLowerCase() === 'lawncare' ||
        String(filterType || '').toLowerCase() === 'landscaping' ||
        String(campaignType || '').toLowerCase() === 'landscaping';

      if (lc) {
        // ====== LAWNCARE LEGEND ======
        return (
          <>
            <Typography variant="subtitle2" gutterBottom>How to read the chips (Lawncare)</Typography>
            <Stack direction="row" spacing={1} sx={{ mb: 2, flexWrap: 'wrap' }}>
              <Chip size="small" label="Need score (lawncare ↑)" sx={{ bgcolor: chipStyles.owner.bg, color: chipStyles.owner.fg, fontWeight: 600 }} />
              <Chip size="small" label="Vendor score (↑)" sx={{ bgcolor: chipStyles.prospector.bg, color: chipStyles.prospector.fg, fontWeight: 600 }} />
              <Chip size="small" label="Homeowner" sx={{ bgcolor: chipStyles.homeowner.bg, color: chipStyles.homeowner.fg, fontWeight: 700 }} />
              <Chip size="small" label="Uncertain" sx={{ bgcolor: chipStyles.uncertain.bg, color: chipStyles.uncertain.fg, fontWeight: 700 }} />
              <Chip size="small" label="facebook / market / type / capturedAt" sx={{ bgcolor:'#E5E7EB' }} />
            </Stack>

            <Typography variant="subtitle2" gutterBottom>Classification thresholds (Lawncare)</Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <strong>Homeowner (needs help)</strong>: OwnerScore ≥ 4 and ProspectorScore ≤ 2.<br/>
              <strong>Prospector / Vendor</strong>: ProspectorScore ≥ 4 (business ad).<br/>
              <strong>Uncertain</strong>: anything else.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle2" gutterBottom>Lawncare signals</Typography>
            <LegendRow label="LC1 — Needs lawn help"          color="#bbf7d0" />
            <LegendRow label="LC2 — Overgrown / long grass"   color="#86efac" />
            <LegendRow label="LC3 — Tree/branch down"         color="#6ee7b7" />
            <LegendRow label="LC4 — HOA / code pressure"      color="#a7f3d0" />
            <LegendRow label="LC5 — Equipment not working"    color="#99f6e4" />
            <LegendRow label="LC6 — ASAP / this week"         color="#d1fae5" />
            <LegendRow label="LC7 — Owner voice present"      color="#bbf7d0" />
            <LegendRow label="LCV — Vendor/Business ad"       color="#fee2e2" />
          </>
        );
      }

      // ====== WHOLESALE LEGEND (default) ======
      return (
        <>
          <Typography variant="subtitle2" gutterBottom>How to read the chips</Typography>
          <Stack direction="row" spacing={1} sx={{ mb: 2, flexWrap: 'wrap' }}>
            <Chip size="small" label="Owner score (distress ↑)" sx={{ bgcolor: chipStyles.owner.bg, color: chipStyles.owner.fg, fontWeight: 600 }} />
            <Chip size="small" label="Prospector/Non-distress (↑)" sx={{ bgcolor: chipStyles.prospector.bg, color: chipStyles.prospector.fg, fontWeight: 600 }} />
            <Chip size="small" label="Homeowner" sx={{ bgcolor: chipStyles.homeowner.bg, color: chipStyles.homeowner.fg, fontWeight: 700 }} />
            <Chip size="small" label="Uncertain" sx={{ bgcolor: chipStyles.uncertain.bg, color: chipStyles.uncertain.fg, fontWeight: 700 }} />
            <Chip size="small" label="facebook / market / type / capturedAt" sx={{ bgcolor:'#E5E7EB' }} />
          </Stack>

          <Typography variant="subtitle2" gutterBottom>Classification thresholds</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            <strong>Homeowner-Distressed</strong>: OwnerScore ≥ 7 and ProspectorScore ≤ 3.<br/>
            <strong>Prospector / Non-distress</strong>: ProspectorScore ≥ 6 (filtered out of results).<br/>
            <strong>Uncertain</strong>: anything else (may include <em>manual review</em> tag if conflicting).
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" gutterBottom>Distress signals (green)</Typography>
          <LegendRow label="D1 — Time pressure / relocation" color="#22c55e" />
          <LegendRow label="D2 — Pre-FC / auction / default" color="#16a34a" />
          <LegendRow label="D3 — Probate / divorce / estate" color="#34d399" />
          <LegendRow label="D4 — Landlord distress" color="#86efac" />
          <LegendRow label="D5 — Repairs / code / insurance" color="#4ade80" />
          <LegendRow label="D6 — Tax / HOA / escrow / utility" color="#2dd4bf" />
          <LegendRow label="D7 — Financial strain (owner voice)" color="#10b981" />
          <LegendRow label="D8 — As-is / fast close" color="#6ee7b7" />
          <LegendRow label="D9 — Vacant / moved out" color="#99f6e4" />
          <LegendRow label="D10 — Date-stamped urgency" color="#a7f3d0" />
          <LegendRow label="R — Recent (≤3 days)" color="#a7f3d0" />

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" gutterBottom>Non-distress & Prospector signals (red)</Typography>
          <LegendRow label="N1 — Lease / rent intent" color="#fecaca" />
          <LegendRow label="N2 — Retail/MLS posture" color="#fca5a5" />
          <LegendRow label="N3 — Refi / keep property" color="#f87171" />
          <LegendRow label="N4 — STR/hosting plans" color="#ef4444" />
          <LegendRow label="N5 — Creative-finance marketing" color="#e11d48" />
          <LegendRow label="N6 — Happy homeowner / keeping" color="#fb7185" />
          <LegendRow label="N7 — No urgency / testing market" color="#f43f5e" />
          <LegendRow label="B1-B10 — Buyer/wholesale signals" color="#ef4444" />
          <LegendRow label="B0 — “your home/house” CTA" color="#f87171" />
          <LegendRow label="REVIEW — Manual review (conflict)" color="#fde68a" />
        </>
      );
    })()}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setLegendOpen(false)} variant="contained">Close</Button>
  </DialogActions>
</Dialog>


  </>
)}














<Dialog open={logViewer.open} onClose={closeLog} fullWidth maxWidth="md">
  <DialogTitle>
  Run Log — {logViewer.scrapeId ? (String(logViewer.scrapeId).slice(0, 8) + '…') : ''}
  {isAutomated(logViewer) && (
    <Chip
      size="small"
      label="Automated"
      sx={{ ml: 1, bgcolor: '#DBEAFE', color: '#1e3a8a', fontWeight: 700 }}
    />
  )}
</DialogTitle>
  <DialogContent dividers>
    {logViewer.loading ? (
      <LinearProgress />
    ) : (
      <Box
        sx={{
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
          fontSize: 13,
          whiteSpace: 'pre-wrap',
        }}
      >
        {logViewer.lines.length === 0 ? (
          <Typography color="text.secondary">No log lines yet.</Typography>
        ) : (
          logViewer.lines.map((l) => {
            const when = l.ts?.toDate
              ? l.ts.toDate()
              : (typeof l.ts === 'number' ? new Date(l.ts) : null);
            return (
              <Box key={l.id} sx={{ display: 'flex', gap: 1, alignItems: 'baseline', mb: 0.5 }}>
                <span style={{ width: 160, color: '#6b7280' }}>
                  {when ? when.toLocaleTimeString() : '—'}
                </span>
                <Chip size="small" label={l.level || 'info'} color={levelColor(l.level)} variant="outlined" />
                 {!!l.meta?.automated && l.meta?.type === 'started' && (
   <Chip size="small" label="Automated" sx={{ ml: .5, bgcolor:'#e0e7ff', color:'#1e3a8a', fontWeight:700 }} />
 )}
                <span style={{ flex: 1 }}>{l.msg || ''}</span>
                {l.meta ? (
                  <span style={{ color: '#6b7280' }}>
                    {typeof l.meta === 'string' ? l.meta : JSON.stringify(l.meta).slice(0, 200)}
                  </span>
                ) : null}
              </Box>
            );
          })
        )}
        <div ref={logEndRef} />
      </Box>
    )}
  </DialogContent>
</Dialog>
      {/* Details Modal */}
      <Dialog open={detailsOpen} onClose={closeDetails} maxWidth="md" fullWidth>
  <DialogTitle sx={{ pr: 6 }}>
    Post details
    <IconButton onClick={closeDetails} sx={{ position: 'absolute', right: 8, top: 8 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers sx={{ p: 0 }}>
    {!!selected && (
      <Container maxWidth="md" sx={{ py: 2.5 }}>
        {/* Header: author + timestamp/permalink */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ mb: 0.25, lineHeight: 1.25 }}>
            {selected.author}
          </Typography>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
            {(selected.timestamp || selected.timeLabel) && (
              <Chip
                size="small"
                label={selected.timeLabel || new Date(selected.timestamp).toLocaleString()}
                sx={{ bgcolor: '#eef2ff', color: '#1f2937', fontWeight: 600 }}
              />
            )}
            {selected.permalink && (
              <Chip
                size="small"
                label="Facebook"
                sx={{ bgcolor: '#DBEAFE', color: '#0b3b8b', fontWeight: 700 }}
              />
            )}
            {selected.lang === 'es' && (
  <Chip size="small" label="Spanish" sx={{ bgcolor:'#bfdbfe', color:'#0b3b8b', fontWeight:700 }} />
)}
            {selected.market && <Chip size="small" label={selected.market} sx={{ bgcolor: '#FEF3C7' }} />}
            {selected.type && <Chip size="small" label={selected.type} sx={{ bgcolor: '#E9D5FF' }} />}
            {selected.capturedAt && (
              <Chip
                size="small"
                label={`Captured: ${new Date(selected.capturedAt).toLocaleString()}`}
                sx={{ bgcolor: '#E5E7EB' }}
              />
            )}
          </Stack>
        </Box>

        {/* Body text */}
<Paper variant="outlined" sx={{ p: 1.5, mb: 2, bgcolor: '#ffffff' }}>
  <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
    {selected.text || 'No content found'}
  </Typography>

  {selected.lang === 'es' && selected.translatedEn && (
    <Box sx={{ mt: 1.25, pt: 1, borderTop: '1px dashed #e5e7eb' }}>
      <Typography variant="caption" sx={{ color: '#6b7280', display: 'block', mb: 0.25 }}>
        Auto-translation
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', fontStyle: 'italic', color: '#374151' }}>
        {selected.translatedEn}
      </Typography>
    </Box>
  )}
</Paper>
{/* AI Summary (from ChatGPT) */}
<Paper
  variant="outlined"
  sx={{
    p: 1.25,
    mb: 2,
    bgcolor: '#ffffff',
    borderColor:
      aiSummary?.verdict === 'good' ? '#86efac' :
      aiSummary?.verdict === 'medium' ? '#fde68a' :
      aiSummary?.verdict === 'bad' ? '#fecaca' : 'divider'
  }}
>
  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75 }}>
    <AutoAwesomeIcon sx={{ color: '#6b7280' }} />
    <Typography variant="subtitle2" sx={{ color: '#374151' }}>AI Summary</Typography>
    {aiSummary?.verdict && (
      <Chip
        size="small"
        label={
          aiSummary.verdict === 'good' ? '✅ Good Lead' :
          aiSummary.verdict === 'medium' ? '⚠️ Medium Lead' :
          aiSummary.verdict === 'bad' ? '❌ Rejected' : String(aiSummary.verdict)
        }
        sx={{
          ml: 'auto',
          fontWeight: 700,
          bgcolor:
            aiSummary.verdict === 'good' ? '#d1fae5' :
            aiSummary.verdict === 'medium' ? '#fef9c3' :
            aiSummary.verdict === 'bad' ? '#fee2e2' : '#e5e7eb'
        }}
      />
    )}
  </Stack>

  {aiSummaryLoading && <LinearProgress sx={{ mb: 1 }} />}

  {!!aiSummaryError && (
    <Typography variant="body2" color="error">
      {aiSummaryError}
    </Typography>
  )}

  {!!aiSummary?.text && (
    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
      {aiSummary.text}
    </Typography>
  )}

  {/* Tiny helper row */}
  {!aiSummaryLoading && !aiSummary && !aiSummaryError && (
    <Typography variant="body2" color="text.secondary">
      No AI summary available.
    </Typography>
  )}
</Paper>
{/* Tree Service — Generate Script */}
{canGenerateScript && (
  <Paper
    variant="outlined"
    sx={{ p: 1.25, mb: 2, bgcolor: '#ffffff', borderColor: '#e5e7eb' }}
  >
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
      <Typography variant="subtitle2" sx={{ color: '#374151' }}>
        Call Script (Tree Service)
      </Typography>

      <Button
        size="small"
        variant="contained"
        onClick={handleGenerateScript}
        disabled={callScriptLoading}
        sx={{ ml: 'auto', textTransform: 'none' }}
      >
        {callScriptLoading ? 'Generating…' : 'Generate script'}
      </Button>
    </Stack>

    {callScriptLoading && <LinearProgress sx={{ mb: 1 }} />}

    {!!callScriptError && (
      <Typography variant="body2" color="error">
        {callScriptError}
      </Typography>
    )}

    {!!callScript && (
      <React.Fragment>
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mb: 1 }}>
          {callScript}
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button
            size="small"
            variant="outlined"
            onClick={() => copyToClipboard(callScript)}
            sx={{ textTransform: 'none' }}
          >
            Copy to clipboard
          </Button>
        </Stack>
      </React.Fragment>
    )}

    {!callScript && !callScriptLoading && !callScriptError && (
      <Typography variant="body2" color="text.secondary">
        Click “Generate script” to create a friendly call opener tailored to this post.
      </Typography>
    )}
  </Paper>
)}

        {/* Scores & Class */}
        <Grid container spacing={1.5} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={6}>
            <Paper variant="outlined" sx={{ p: 1.25 }}>
              <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
                Scores
              </Typography>
              <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
                <Chip
                  size="small"
                  label={`Owner ${selected.ownerScore ?? 0}`}
                  sx={{ bgcolor: '#d1fae5', color: '#065f46', fontWeight: 600 }}
                />
                <Chip
  size="small"
  label={`${isLCSelected ? 'Need' : 'Owner'} ${selected.ownerScore ?? 0}`}
  sx={{ bgcolor: '#d1fae5', color: '#065f46', fontWeight: 600 }}
/>
<Chip
  size="small"
  label={`${isLCSelected ? 'Vendor' : 'Prospector'} ${selected.prospectorScore ?? 0}`}
  sx={{ bgcolor: '#fee2e2', color: '#7f1d1d', fontWeight: 600 }}
/>
                <Chip
                  size="small"
                  label={(selected.classification ?? 'uncertain')}
                  sx={{
                    bgcolor: (selected.classification === 'homeowner' ? '#dcfce7' : '#fde68a'),
                    color: (selected.classification === 'homeowner' ? '#065f46' : '#7c2d12'),
                    fontWeight: 700,
                    textTransform: 'capitalize'
                  }}
                />
              </Stack>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper variant="outlined" sx={{ p: 1.25 }}>
              <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
                Meta
              </Typography>
              <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
                <Chip size="small" label={selected.platform || 'facebook'} sx={{ bgcolor: '#DBEAFE' }} />
                {selected.market && <Chip size="small" label={selected.market} sx={{ bgcolor: '#FEF3C7' }} />}
                {selected.type && <Chip size="small" label={selected.type} sx={{ bgcolor: '#E9D5FF' }} />}
                {selected.capturedAt && (
                  <Chip size="small" label={new Date(selected.capturedAt).toLocaleString()} sx={{ bgcolor: '#E5E7EB' }} />
                )}
              </Stack>
            </Paper>
          </Grid>
        </Grid>
{/* Review summary (if present) */}
{(selected?.review?.verdict || selected?.review?.reason) && (
  <Paper variant="outlined" sx={{ p: 1.25, mb: 2 }}>
    <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
      Review
    </Typography>
    <Stack spacing={0.5}>
      {selected?.review?.verdict && (
        <Chip
          size="small"
          label={selected.review.verdict === 'up' ? 'Approved' : 'Rejected'}
          sx={{ width: 'fit-content', bgcolor: selected.review.verdict === 'up' ? '#d1fae5' : '#fee2e2', fontWeight: 700 }}
        />
      )}
      {selected?.review?.reason && (
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
          {selected.review.reason}
        </Typography>
      )}
    </Stack>
  </Paper>
)}
{/* Backend AI classification */}
{(selected?.verdict || selected?.reason) && (
  <Paper variant="outlined" sx={{ p: 1.25, mb: 2 }}>
    <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
      Lead Classification
    </Typography>
    <Stack spacing={0.5}>
      {selected?.verdict && (
        <Chip
          size="small"
          label={
            selected.verdict === 'good'
              ? '✅ Good Lead'
              : selected.verdict === 'medium'
              ? '⚠️ Medium Lead'
              : '❌ Rejected'
          }
          sx={{
            width: 'fit-content',
            bgcolor:
              selected.verdict === 'good'
                ? '#d1fae5'
                : selected.verdict === 'medium'
                ? '#fef9c3'
                : '#fee2e2',
            fontWeight: 700,
          }}
        />
      )}
      {selected?.reason && (
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
          {selected.reason}
        </Typography>
      )}
    </Stack>
  </Paper>
)}
        {/* Signals */}
        <Grid container spacing={1.5} sx={{ mb: 2 }}>
          <Grid item xs={12} md={6}>
            <Paper variant="outlined" sx={{ p: 1.25, height: '100%' }}>
              <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
                Distress Signals
              </Typography>
              <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
                {ownerTags.length > 0
                  ? ownerTags.map(t => <Chip key={`own-${t.id}`} size="small" label={t.label} sx={{ bgcolor: t.color }} />)
                  : <Typography variant="body2" color="text.secondary">None detected.</Typography>}
              </Stack>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper variant="outlined" sx={{ p: 1.25, height: '100%' }}>
<Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
  {isLCSelected ? 'Lawncare Signals'
   : isRoofingSelected ? 'Roofing Signals'
   : 'Distress Signals'}
</Typography>

<Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
  {isLCSelected ? 'Vendor / Anti-Signals'
   : isRoofingSelected ? 'Roofing Vendor / Spam'
   : 'Prospector / Anti-Signals'}
</Typography>
              <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
                {prospectorTags.length > 0
                  ? prospectorTags.map(t => <Chip key={`pro-${t.id}`} size="small" label={t.label} sx={{ bgcolor: t.color }} />)
                  : <Typography variant="body2" color="text.secondary">None detected.</Typography>}
              </Stack>
            </Paper>
          </Grid>
        </Grid>

        {/* Actions */}
        <Paper variant="outlined" sx={{ p: 1.25, bgcolor: '#fbfbfb' }}>
          <Grid container spacing={1.25}>
            {/* Navigation */}
            <Grid item xs={12} md={4}>
              <Typography variant="caption" sx={{ color: '#6b7280' }}>
                Navigate
              </Typography>
              <ButtonGroup orientation="horizontal" fullWidth sx={{ mt: 0.75 }}>
  <Button
    variant="outlined"
    disabled={!selected.profileUrl}
    onClick={() => selected.profileUrl && window.open(selected.profileUrl, '_blank')}
  >
    View Profile
  </Button>
<Button
  variant="contained"
  disabled={!selected.postUrl}
  onClick={() => selected.postUrl && window.open(selected.postUrl, '_blank')}
>
  View Post
</Button>
</ButtonGroup>
            </Grid>

            {/* Lead actions */}
           <Grid item xs={12} md={4}>
  <Typography variant="caption" sx={{ color: '#6b7280' }}>
    Lead
  </Typography>
  <Grid container spacing={1} sx={{ mt: 0.75 }}>
    <Grid item xs={12}>
      <Button
        fullWidth
        disabled
        variant="outlined"
        onClick={() => saveOneToFirestore(selected)}
      >
        Saved to DB
      </Button>
    </Grid>
    <Grid item xs={12} md={4}>
  <Typography variant="caption" sx={{ color: '#6b7280' }}>
    Danger
  </Typography>
  <Stack direction="row" spacing={1} sx={{ mt: 0.75 }}>
    <Button
      fullWidth
      variant="outlined"
      color="error"
      disabled={!selected || deleting}
      onClick={() => handleDeleteFromDB(selected)}
    >
      {deleting ? 'Deleting…' : 'Delete from DB'}
    </Button>
  </Stack>
  
</Grid>
{/* ✏️ In Lead actions area (Details modal) */}
<Grid item xs={12}>
  <Button
    fullWidth
    variant={bradKeys.has(makeKey(selected)) ? 'outlined' : 'contained'}
    color="primary"
    onClick={(e) => toggleBrad(selected, e)}
  >
    {bradKeys.has(makeKey(selected)) ? 'Remove from Brad Leads' : 'Add to Brad Leads'}
  </Button>
</Grid>
  
    {!isLCSelected && (
  <Grid item xs={12}>
    <Button
      fullWidth
      color="secondary"
      variant="contained"
      onClick={handleOpenSkipTrace}
    >
      Skip Trace
    </Button>
  </Grid>
)}
  </Grid>
</Grid>

            {/* Review (prominent, separated) */}
            <Grid item xs={12} md={4}>
              <Typography variant="caption" sx={{ color: '#6b7280' }}>
                Review
              </Typography>
              <Stack direction="row" spacing={1} sx={{ mt: 0.75 }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="success"
                  startIcon={<ThumbUpAltIcon />}
                  onClick={()=>openReview('up')}
                >
                  Approve
                </Button>
                <Button
                  fullWidth
                  variant="outlined"
                  color="error"
                  startIcon={<ThumbDownAltIcon />}
                  onClick={()=>openReview('down')}
                >
                  Reject
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Paper>
        {/* Timeline & Notes */}
<Paper variant="outlined" sx={{ p: 1.25, mt: 2 }}>
  <Typography variant="subtitle2" sx={{ mb: 1.5, color: '#374151' }}>
    Timeline & Notes
  </Typography>

  {/* Add note */}
  <Grid container spacing={1} sx={{ mb: 2 }}> {/* ⬅ more bottom margin */}
    <Grid item xs={12} md={9}>
      <TextField
        fullWidth
        size="small"
        label="Add a note"
        placeholder="e.g., Left voicemail, follow up tomorrow."
        value={noteText}
        onChange={(e)=>setNoteText(e.target.value)}
      />
    </Grid>
    <Grid item xs={12} md={3} sx={{ display:'flex', alignItems:'stretch' }}>
      <Button
        fullWidth
        variant="contained"
        disabled={!noteText.trim() || !selected}
        onClick={async ()=>{
          const text = noteText.trim();
          if (!text || !selected) return;
          await logEvent(selected, 'note', { note: text });
          setNoteText('');
          setTimelineLoading(true);
          setTimeline(await fetchTimeline(selected));
          setTimelineLoading(false);
        }}
      >
        Add Note
      </Button>
    </Grid>
  </Grid>

  {/* Events list */}
  <Box sx={{ maxHeight: 260, overflow: 'auto', pr: 1 }}>
    {timelineLoading ? (
      <LinearProgress />
    ) : timeline.length === 0 ? (
      <Typography variant="body2" color="text.secondary">
        No activity yet.
      </Typography>
    ) : (
      <Stack spacing={2} sx={{ pl: 3 }}> {/* ⬅ less indent */}
        {timeline.map((e) => {
          const type = e.type || 'event';
          const payload = e.payload || {};
          const serverDate = e.at?.toDate ? e.at.toDate() : (e.at ? new Date(e.at) : null);
          const sourceOverride = payload.sourceTs ? new Date(payload.sourceTs) : null;
          const when = sourceOverride || serverDate;
          const whenStr = when ? when.toLocaleString() : '—';

          let icon = null, label = '';
          switch (type) {
            case 'captured': icon = <AddCircleOutlineIcon fontSize="small" sx={{ color: '#3b82f6' }} />; label = 'Captured'; break;
            case 'call': icon = <PhoneInTalkIcon fontSize="small" sx={{ color: '#10b981' }} />; label = `Called ${payload.number ? phoneMask(payload.number) : ''}`.trim(); break;
            case 'review_up': icon = <ThumbUpAltIcon fontSize="small" sx={{ color: '#16a34a' }} />; label = 'Approved'; break;
            case 'review_down': icon = <ThumbDownAltIcon fontSize="small" sx={{ color: '#dc2626' }} />; label = 'Rejected'; break;
            case 'note': icon = <NoteAltIcon fontSize="small" sx={{ color: '#7c3aed' }} />; label = payload.note || 'Note'; break;
            case 'saved': icon = <BookmarkBorderIcon fontSize="small" sx={{ color: '#0ea5e9' }} />; label = 'Saved lead'; break;
            case 'unsaved': icon = <BookmarkBorderIcon fontSize="small" sx={{ color: '#94a3b8' }} />; label = 'Unsaved lead'; break;
            default: icon = <AccessTimeIcon fontSize="small" sx={{ color: '#6b7280' }} />; label = type;
          }

          return (
            <Box key={e.id} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
              {/* circle with icon */}
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  bgcolor: '#fff',
                  border: '2px solid #d1d5db',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {icon}
              </Box>

              {/* content */}
              <Box sx={{ flex: 1, pt: 0.25 }}>
                <Typography variant="body2" sx={{ lineHeight: 1.3, mb: 0.25 }}>
                  {label}
                </Typography>
                  {(type === 'review_up' || type === 'review_down') && payload?.reason && (
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        mb: 0.25,
        fontStyle: 'italic',
        color: '#374151'
      }}
    >
      Reason: {payload.reason}
    </Typography>
  )}
                <Typography variant="caption" color="text.secondary">
                  {whenStr}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Stack>
    )}
  </Box>
</Paper>
      </Container>
    )}
  </DialogContent>
</Dialog>

      {/* Review Dialog */}
      <Dialog open={reviewOpen} onClose={closeReview} maxWidth="sm" fullWidth>
        <DialogTitle>
          {reviewVerdict === 'up' ? 'Approve Lead (Thumbs Up)' : 'Reject Lead (Thumbs Down)'}
          <IconButton onClick={closeReview} sx={{ position:'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selected && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>{selected.author}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace:'pre-wrap' }}>
  {cleanFbNoise(selected?.text || '').slice(0, 500)}
  {cleanFbNoise(selected?.text || '').length > 500 ? '…' : ''}
</Typography>
            </Box>
          )}
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={3}
            label={`Reason for ${reviewVerdict === 'up' ? 'approval' : 'rejection'} (required)`}
            value={reviewReason}
            onChange={(e)=>setReviewReason(e.target.value)}
helperText={
  isLCSelected
    ? 'Be specific (e.g., clear need, owner voice, HOA/code, overgrown, ASAP, not a vendor ad).'
    : 'Be specific (e.g., distress signal, owner-voice, red flags, etc.)'
}          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeReview}>Cancel</Button>
          <Button
            variant="contained"
            disabled={reviewSubmitting || !reviewReason.trim()}
            onClick={submitReview}
          >
            {reviewSubmitting ? 'Saving…' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
{/* Skip Trace Dialog */}
<Dialog open={skipOpen} onClose={handleCloseSkipTrace} maxWidth="md" fullWidth>
  <DialogTitle>
    Skip Trace
    <IconButton onClick={handleCloseSkipTrace} sx={{ position:'absolute', right: 8, top: 8 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    {/* Query controls */}
    <Grid container spacing={1.25}>
      <Grid item xs={12} md={4}>
        <FormControl size="small" fullWidth>
          <InputLabel>Mode</InputLabel>
          <Select
            label="Mode"
            value={skipMode}
            onChange={(e)=>setSkipMode(e.target.value)}
          >
            <MenuItem value="byname">By Name</MenuItem>
            <MenuItem value="byaddress">By Address</MenuItem>
            <MenuItem value="bynameaddress">Name + City/State/ZIP</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={8}>
        <TextField
          fullWidth
          size="small"
          label="Name"
          placeholder="Jane Doe"
          value={skipQuery.name}
          onChange={(e)=>setSkipQuery(q=>({ ...q, name: e.target.value }))}
        />
      </Grid>

      {skipMode !== 'byname' && (
        <>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="Street"
              placeholder="123 Main St"
              value={skipQuery.street}
              onChange={(e)=>setSkipQuery(q=>({ ...q, street: e.target.value }))}
              disabled={skipMode === 'bynameaddress'}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="City, ST [ZIP]"
              placeholder="Arlington, VA 22203"
              value={skipQuery.citystatezip}
              onChange={(e)=>setSkipQuery(q=>({ ...q, citystatezip: e.target.value }))}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <Stack direction="row" spacing={1} sx={{ justifyContent:'flex-end' }}>
          <Button onClick={()=>setSkipQuery({ name:'', street:'', citystatezip:'' })}>Clear</Button>
          <Button
            variant="contained"
            onClick={()=>doSkipSearch(1)}
            disabled={skipLoading || (!skipQuery.name && skipMode!=='byaddress')}
          >
            {skipLoading ? 'Searching…' : 'Search'}
          </Button>
        </Stack>
      </Grid>
    </Grid>

    {/* Error */}
    {!!skipError && (
      <Typography color="error" sx={{ mt: 2 }}>{skipError}</Typography>
    )}

    {/* Results */}
{/* Results: visible cards with DMV-first "Most Likely" */}
<Box sx={{ mt: 2 }}>
  {skipLoading && <LinearProgress />}

  {!skipLoading && Array.isArray(skipResults) && skipResults.length > 0 && (() => {
    // IMPORTANT: this 'state' is your UI market picker (e.g., "DMV", "Maryland", etc.)
    const ctx = { market: state, nameHint: skipQuery.name, cityStateZipHint: skipQuery.citystatezip };
    const scored = scoreSortAndFlag(skipResults, ctx);

    return (
      <Grid container spacing={1.25}>
        {scored.map((r, i) => {
          const id = recId(r) || String(i);
          const name = recName(r) || 'Unknown Name';
          const lives = recLivesIn(r) || 'Location unknown';
          const { state: rState } = parseCityState(lives);
          const inDMV = DMV.has(rState);

          return (
            <Grid item xs={12} sm={6} md={4} key={id}>
              <Paper
                variant="outlined"
                sx={{
                  p: 1,
                  borderRadius: 1.5,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: .75,
                  height: '100%',
                  borderColor: r.__isTop ? (inDMV ? '#10b981' : '#3b82f6') : undefined,
                  boxShadow: r.__isTop ? 2 : 0
                }}
              >
                <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap: .75 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, pr: .5, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                    {name}
                  </Typography>
                  <Stack direction="row" spacing={0.75} sx={{ flexWrap:'wrap' }}>
                    {r.__isTop && (
                      <Chip
                        size="small"
                        label={inDMV ? 'Most Likely (DMV)' : 'Most Likely'}
                        sx={{ bgcolor: inDMV ? '#bbf7d0' : '#bfdbfe', fontWeight: 700 }}
                      />
                    )}
                    {/* <Chip size="small" label={`Score: ${r.__score}`} sx={{ bgcolor:'#fef3c7' }} /> */}
                    {inDMV && <Chip size="small" label="DMV" sx={{ bgcolor:'#d1fae5', color:'#065f46', fontWeight:700 }} />}
                  </Stack>
                </Box>

                <Typography variant="caption" color="text.secondary">
                  {lives}
                </Typography>

                <Box sx={{ mt: .5, display:'flex', justifyContent:'flex-end', gap: .75 }}>
                  <Button size="small" variant="text" onClick={()=>getDetailsFor(r)}>
                    DETAILS
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={()=>{ setSkipSelected(r); getDetailsFor(r); }}
                  >
                    SELECT
                  </Button>
                </Box>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    );
  })()}

  {!skipLoading && Array.isArray(skipResults) && skipResults.length === 0 && (
    <Typography variant="body2" color="text.secondary">
      No results yet. Enter a query and click Search.
    </Typography>
  )}
</Box>

    {/* Selected details */}
{/* Selected details */}

{!!skipSelected && skipDetail && (
  <Box sx={{ mt: 3 }}>
    <Divider sx={{ mb: 2 }} />
    <Typography variant="subtitle2" sx={{ mb: 1 }}>
      Selected Person
    </Typography>
    <Box sx={{ mt: 1.5, display:'flex', justifyContent:'flex-end', gap: 1 }}>
  <Button
    variant="contained"
    disabled={!selected || !skipDetail}
    onClick={async ()=>{
      try {
        await attachSkipTraceToLead(selected, skipDetail);
        // refresh local selected with a minimal merge so chips/exports see it
        setSelected((prev)=> prev ? ({ ...prev, skipTrace: {
          summary: getSummary(skipDetail),
          phones:  getPhones(skipDetail),
          emails:  getEmails(skipDetail),
          addresses: getAddresses(skipDetail),
          relatives: getRelatives(skipDetail),
        }}) : prev);
      } catch(e) {
        setError(e?.message || String(e));
      }
    }}
  >
    Add skip trace to lead
  </Button>
</Box>
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      {recName(skipSelected) || '—'}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      {recLivesIn(skipSelected) || '—'}
    </Typography>

    <Grid container spacing={1.25}>
      {/* Summary */}
      <Grid item xs={12} md={4}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Summary
          </Typography>
          {(() => {
            const sm = getSummary(skipDetail);
            const rows = [
              ['Name', sm.name || '—'],
              ['Age', sm.age || '—'],
              ['DOB', sm.dob || '—'],
            ];
            return (
              <Box
                component="dl"
                sx={{
                  m: 0,
                  display: 'grid',
                  gridTemplateColumns: 'auto 1fr',
                  rowGap: 0.25,
                  columnGap: 1,
                }}
              >
                {rows.map(([k, v]) => (
                  <React.Fragment key={k}>
                    <Typography component="dt" variant="caption" sx={{ color: '#6b7280' }}>
                      {k}
                    </Typography>
                    <Typography component="dd" variant="body2" sx={{ m: 0 }}>
                      {v}
                    </Typography>
                  </React.Fragment>
                ))}
              </Box>
            );
          })()}
        </Paper>
      </Grid>

      {/* Phones */}
      <Grid item xs={12} md={4}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Phones
          </Typography>
          {(() => {
            const phones = getPhones(skipDetail);
            return phones.length ? (
              <Stack spacing={0.5}>
                {phones.map((p, i) => {
                  const masked = phoneMask(p.raw);
                  const meta = [p.type, p.provider, p.last].filter(Boolean).join(' • ');
                  return (
                    <Box
                      key={`${p.raw}-${i}`}
                      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                    >
                      <Box>
                        <Typography variant="body2">{masked || '—'}</Typography>
                        {!!meta && (
                          <Typography variant="caption" color="text.secondary">
                            {meta}
                          </Typography>
                        )}
                      </Box>
                      <Button
  size="small"
  variant="contained"
  onClick={() => openDialer(p.raw)}
>
  Call
</Button>
                    </Box>
                  );
                })}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No phone numbers.
              </Typography>
            );
          })()}
        </Paper>
      </Grid>
<Dialog open={callOpen} onClose={closeDialer} maxWidth="xs" fullWidth>
  <DialogTitle>
    Calling
    <IconButton onClick={closeDialer} sx={{ position: 'absolute', right: 8, top: 8 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: 0.5 }}>
        {callNumber || '—'}
      </Typography>

      <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
        {callStep < 3 ? <LinearProgress sx={{ width: 140 }} /> : null}
        <Chip
          color={callStep === 3 ? 'success' : 'default'}
          label={
            ['Dialing…', 'Ringing…', 'Connecting…', 'Connected'][callStep]
          }
          sx={{ fontWeight: 600 }}
          size="small"
        />
      </Stack>

      {/* step dots */}
      <Stack direction="row" spacing={0.75} sx={{ mt: 1 }}>
        {[0,1,2,3].map(i => (
          <Box
            key={i}
            sx={{
              width: 8, height: 8, borderRadius: '50%',
              bgcolor: i <= callStep ? '#3b82f6' : '#e5e7eb',
              transition: 'background-color .2s'
            }}
          />
        ))}
      </Stack>
      

      
    </Box>
  </DialogContent>

  <DialogActions>
    {callStep < 3 ? (
      <Button onClick={closeDialer} color="error" variant="outlined">Cancel</Button>
    ) : (
      <Button onClick={closeDialer} color="error" variant="contained">Hang Up</Button>
    )}
  </DialogActions>
</Dialog>
      {/* Emails */}
      <Grid item xs={12} md={4}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Emails
          </Typography>
          {(() => {
            const emails = getEmails(skipDetail);
            return emails.length ? (
              <Stack spacing={0.5}>
                {emails.map((addr, i) => (
                  <Box
                    key={`${addr}-${i}`}
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                  >
                    <Typography variant="body2">{addr}</Typography>
                    <Button size="small" onClick={() => navigator.clipboard.writeText(addr)}>
                      COPY
                    </Button>
                  </Box>
                ))}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No emails found.
              </Typography>
            );
          })()}
        </Paper>
      </Grid>

      {/* Address History */}
      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Address History
          </Typography>
          {(() => {
            const addrs = getAddresses(skipDetail);
            return addrs.length ? (
              <Grid container spacing={1}>
                {addrs.map((a, i) => {
                  const line = [a.line, [a.city, a.state].filter(Boolean).join(', '), a.zip]
                    .filter(Boolean)
                    .join(' • ');
                  return (
                    <Grid key={`${a.line}-${a.city}-${a.state}-${a.zip}-${i}`} item xs={12} md={6}>
                      <Box sx={{ border: '1px solid #e5e7eb', borderRadius: 1, p: 1 }}>
                        <Typography variant="body2">{line || '—'}</Typography>
                        {a.span && (
                          <Typography variant="caption" color="text.secondary">
                            {a.span}
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No address history.
              </Typography>
            );
          })()}
        </Paper>
      </Grid>

      {/* Relatives */}
      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Relatives / Associates
          </Typography>
          {(() => {
            const rels = getRelatives(skipDetail);
            return rels.length ? (
              <Grid container spacing={1}>
                {rels.map((r, i) => (
                  <Grid item xs="auto" key={`${r.name}-${i}`}>
                    <Chip size="small" label={`${r.name}${r.relation ? ` • ${r.relation}` : ''}`} />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Typography variant="body2" color="text.secondary">
                None listed.
              </Typography>
            );
          })()}
        </Paper>
      </Grid>
    </Grid>
  </Box>
)}



  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseSkipTrace}>Close</Button>
  </DialogActions>
</Dialog>

      {/* Progress Modal */}
      <Dialog open={loading} fullWidth maxWidth="sm">
        <DialogTitle>Working on it…</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Target: {target} lead{target===1?'':'s'}
          </Typography>
          <LinearProgress variant="determinate" value={progress} />
          <Box sx={{ display:'flex', justifyContent:'space-between', mt: 1 }}>
            <Typography variant="body2">{phase}</Typography>
            <Typography variant="body2">{progress}% {eta && `• ${eta}`}</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
function LegendRow({ label, color }) {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 1 }}>
      <Box sx={{ width: 14, height: 14, borderRadius: '4px', bgcolor: color }} />
      <Typography variant="body2">{label}</Typography>
    </Stack>
  );
}